import { RESELLER_GUIDE, RESELLER_PROG_TANDC } from "../config/constants";

const uplvlRenewTranslation = {
  en_US: {
    uplevelRenewal: {
      PP_APC_Header_Label: "Adobe Partner Connection Portal",
      //"OnbrdCriteriaAuthoriseMsg": "Please check where indicated to confirm that you are authorised to complete this application on behalf of your organisation.",
      OnbrdTermsPartnerCodeMsg:
        "Please review the terms and conditions and the Adobe Business Partner Code of Conduct and check where indicated to confirm your acceptance.",
      OnbrdContactPrefLang: "Preferred Language *",
      //"PP_Adobe_Portal": "Adobe Partners",
      //"ONBLangPref": "Region & Language",
      //"OnbrdCriteriaHeader": "Registration Criteria",
      OnbrdCriteriaHeaderRenewal: "Renewal Criteria",
      OnbrdCriteriaHeaderUplevel: "Uplevel Criteria",
      ONBCompInfo: "Company Info",
      ONBContsInfo: "Contact Info",
      SplznQuestionnaireHeader: "Questionnaire",
      ONBPgmAgreement: "Program Agreement",
      ONBPreferredLanguage:
        "Please select the location of your organization and your preferred language.",
      //"OnbrdProfileRegion": "Region",
      //"OnbrdGenSelectErrorMsg": "Please select a value.",
      OnbrdProfileCountry: "Country",
      //"OnbrdGenNone": "--None--",
      ONBRegCriteriaAgree:
        "Please review the registration criteria and indicate your acceptance.",
      OnbrdCriteriaBody:
        "Thank you for your interest in the Adobe Partner Connection Reseller Program.",
      OnbrdCriteriaBodyRenewal:
        "Thank you for your interest in renewing your membership in the Adobe Partner Connection Reseller Program.",
      OnbrdCriteriaBodyUplevel:
        "Thank you for your interest in upgrading your membership in the Adobe Partner Connection Reseller Program.",
      OnbrdCriteriaBody1:
        "Please review the Reseller Program requirements for your desired level and the registration criteria below. When you are ready to proceed, confirm that you are authorised to complete this application. Then click Next to continue.",
      //remove this sentence Your path to membership begins with this online enrolment process.
      OnbrdCriteriaSectionHeader: "REGISTRATION CRITERIA",
      //"OnbrdCriteriaSectionHeaderRenewal": "RENEWAL CRITERIA",
      //"OnbrdCriteriaSectionHeaderUplevel": "UPLEVEL CRITERIA",
      OnbrdCriteriaAuthorized: "an officer or director of the company or",
      //--
      OnbrdCriteriaAuthorized2:
        "a person expressly authorised by an officer or director to complete this application on behalf of the company.",
      ONBEnterCompDetails:
        "Please provide the following information about your organization.",
      OnbrdProfileMembershipId: "Membership ID",
      OnbrdProfileParentMembershipId: "Parent Membership ID",
      OnbrdProfileContractStart: "Contract Start Date",
      OnbrdProfilePartnerLevel: "Partner Level",
      OnbrdProfileContractEnd: "Contract End Date",
      OnbrdProfileSplzn: "Specialisation",
      //"OnbrdProfileAcctMgr": "Account Manager",
      OnbrdProfileAddLicenses: "# Additional Licenses",
      OnbrdProfileFullCompName: "Full Company Name",
      //"OnbrdGenInputErrorMsg": "Please enter a value.",
      OnbrdProfileTradingName: "Trading Name",
      OnbrdProfileBRN: "Business Registration Number",
      OnbrdProfilePreferredDistributor: "Preferred Distributor",
      OnbrdProfileYrIncorp: "Year Established *",
      //"OnbrdGenInvalidYrFormat": "Please follow year format: YYYY",
      //"OnbrdGenInvalidYr": "Invalid Year.",
      //"OnbrdGenInvalidFutureDateMsg": "Date is set in the future. Please enter a valid date.",
      OnbrdProfileCompType: "Company Type (select all that apply) *",
      OnbrdGenSelectErrorMsg: "Please select a value.",
      //"OnbrdProfileCountry": "Country/Region",
      //"OnbrdGenNone": "--None--",
      OnbrdProfileStreet: "Street *",
      OnbrdProfileCity: "City *",
      OnbrdProfileState: "State/Province *",
      OnbrdProfilePostCode: "Postal Code *",
      OnbrdProfilePrimPhone: "Primary Phone *",
      OnbrdProfilePrimFax: "Primary Fax",
      OnbrdProfileContactEmail: "Email Address *",
      //"OnbrdGenEmailFormatErrMsg": "Invalid email format.",
      //"OnbrdProfileCompanyDomainMsg": "The company email domain that you've entered does not match the primary contact's email domain.",
      //"OnbrdProfileEmailDomain": "Email Domain",
      OnbrdProfilePrimURL: "Website *",
      OnbrdProfileSecondaryURL: "Secondary Website",
      //"OnbrdProfileListPartnerFinder": "List in Reseller Finder?",
      ONBContactDetails:
        "Please provide the contact information for your organization.",
      //make it small, contact type active not present , company email
      OnbrdContactSecContactInfo: "Contact Information",
      OnbrdContactSectionHeader:
        "Please provide the contact information for your organisation.<br/>\nNOTE: Primary and secondary contacts are required. You may add additional contacts so we can contact you for sales, marketing, and technical updates.",
      ONBAddSecBtn: "Add Secondary",
      ONBAddOtherBtn: "Add Other",
      ReAssignContactNameLabel: "Contact Name",
      ConsolePartnerContactEmail: "EMAIL",
      ConsolePartnerContactCType: "Main Contact Type",
      //"TrngManage": "Manage",
      OnbrdContactPrimaryType: "Primary",
      OnbrdContactSecondaryType: "Secondary",
      OnbrdContactOtherType: "Other",
      ConsolePartnerBtnEdit: "Edit",
      QBPDelete: "Delete",
      OnbrdContactPriConHeader: "Primary Contact",
      OnbrdContactSecConHeader: "Secondary Contact",
      OnbrdContactOther: "Other Contacts",
      OnbrdContactPrefix: "Prefix",
      OnbrdContactTitle: "Suffix/Title",
      prefixMaxLengthError:
        "Prefix must be 10 characters or fewer, Kindly update.",
      suffixMaxLengthError:
        "Suffix must be 10 characters or fewer, Kindly update.",
      OnbrdContactFName: "First Name *",
      OnbrdContactLName: "Last Name *",
      OnbrdContactPhone: "Phone *",
      OnbrdContactJRole: "Job Role *",
      OnbrdContactEmail: "Email *",
      //"OnbrdContactAddtlType": "Type",
      //"OnbrdContactDeactivate": "Deactivate",
      OnbrdContactDeactivateHelp:
        "Checking the Deactivate box will remove this contact from the account. This contact will no longer have access to Adobe systems.",
      TrngSaveClose: "Save and Close",
      TrngClose: "Close",
      ONBRegCerContacts:
        "Please select and complete the required COC training course before submitting your request.",
      OnbrdCertContactSectionHeader:
        "Sales training is required for your desired level. A minimum of one person must complete the \u201c Partner Code of Conduct\u201d training. See the Adobe Partner Connection Reseller or Retail Program Guide for a complete list of training requirements. Identify the contacts who have completed the required training in the fields below.",
      OnbrdContactAdd: "Add Another Contact",
      //"OnbrdCertContactFName": "FIRST NAME",
      //"OnbrdCertContactLName": "LAST NAME",
      //"OnbrdCertContactEmail": "EMAIL",
      OnbrdCertContactCertification: "TRAINING COURSE COMPLETED",
      //"TrngManage": "Manage",
      ConsolePartnerBtnEdit: "Edit",
      ONBCerContactDetails: "Certified Contact details",
      //"OnbrdCertContactDeactivated": "DEACTIVATE",
      ONBRetailSplQues: "Retail Program Specialization Questionnaire",
      OnbrdPrimaryQuestionnaireHeader: "Registration Compliance Questionnaire",
      OnbrdSecondaryQuestionnaireHeader: "Registration Secondary Questionnaire",
      OnbrdPartnerFinderInfoHeader: "Registration Business Questionnaire",
      ONBAgreeToSubmit:
        "Please review the program agreement and indicate your acceptance.",
      OnbrdTermsSectionHeader2:
        "Please review the Reseller Program terms and conditions. You will need to scroll down to confirm your acceptance where indicated.",
      OnbrdTermsSectionHeader: "Terms & Conditions",
      OnbrdTermsAccept:
        "I HAVE READ, UNDERSTOOD, AND AGREED TO COMPLY WITH THE TERMS AND CONDITIONS INDICATED HEREIN AND REPRESENT AND WARRANT THAT I AM AUTHORIZED TO BIND THE RESELLER.",
      OnbrdThankYouNewRegistered:
        "<br/>\nThank you for your interest in the Adobe Partner Connection Reseller Program. We have received your application. You will receive a confirmation email shortly. We will continue to notify you via email of any updates regarding your application.<br/><br/>",
      OnbrdThankYouRenewalRegistered:
        "Your renewal has been filed and you will receive a confirmation email shortly.",
      OnbrdThankYouRenewalCertGold:
        "Your renewal has been filed and you will receive a confirmation email shortly.",
      OnbrdThankYouUplevelCertGold:
        "Thank you for your interest in upgrading to a new level in the Adobe Partner Connection Reseller Program. We have received your application for the new level. You will receive a confirmation email shortly. We will continue to notify you via email of any updates regarding your application.",
      OnbrdThankYouClick: "Click",
      //"OnbrdThankYouEducURL": "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=Education&id=",
      OnbrdThankYouHere: "here",
      OnbrdThankYouEd: "to renew your Education Specialization.",
      //"OnbrdThankYouLegalURL": "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=SAM+services&id=",
      OnbrdThankYouLeg: "to renew your SAM Services Specialisation.",
      //"OnbrdThankYouProVedioURL": "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=ProVideo&id=",
      OnbrdThankYouPv: "to renew your ProVideo Specialization.",
      //"OnbrdThankYouGovURL": "http://adobedealreg.sfqa.cs12.force.com/Onboarding/SplznWizardPage?sp=Government&id=",
      OnbrdThankYouGv: "to Renew your Government Specialization.",
      //"OnbrdThankYouDpsURL": "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=DigitalPublishingSuite&id=",
      OnbrdThankYouDps:
        "to Renew your Digital Publishing Suite  Specialization.",
      OnbrdThankYouHelpDesk:
        "If you need assistance, please contact the Adobe Partner Connection Help Desk.",
      OnbrdErrorUnauthorized:
        "Sorry, you are unauthorized to view the page. Please contact the Partner Help Desk for help with registering/upleveling.",
      OnbrdErrorNewRegEmailExist:
        "<br/><br/>\n<p>Could not process your registration because your email address already exists in the system.</p>\n<br/><br/><br/><br/><br/>",
      OnbrdErrorNewRegEmailFree:
        "<br/><br/> \n<p>Free email domains and ISPs are disallowed as company and primary contact email domains. Please sign up for an Adobe ID with a corporate email account.</p> \n<br/><br/><br/><br/><br/>",
      OnbrdErrorExpiredLink:
        "<br/><br/>\n<p>You link is already expired. Please contact the Partner Help Desk.</p>\n<br/><br/><br/><br/><br/>",
      OnbrdInterimUplevelExistsMsg:
        "Thank you for your interest in upgrading to a new level in the Adobe Partner Connection Program. We are already reviewing a previously submitted application for the new level. We will notify you via email of any updates regarding your application.",
      OnbrdProgNextStepExistMsg:
        "This Reseller is already registered for the Adobe Partner Connection Program. Please contact the Adobe Partner Connection Help Desk.",
      Previous: "Previous",
      "Save and Exit": "Save and Exit",
      Submit: "Submit",
      Next: "Next",
      renewal_unauthorized: "Sorry, you are unauthorized to view the page.",

      PP_Adobe_Portal: "Adobe Partners",
      PP_APC_Header_Label: "Adobe Partner Connection Portal",
      ONBUplevelInfo: "Please select your desired level.",
      ONBNewLevel: "New Level",
      OnbrdInterimUplevelHeader:
        "Please select the level for which you want to apply.",
      OnbrdGenCertifiedLevel: "Certified",
      OnbrdGenGoldLevel: "Gold",
      OnbrdGenErrorLabel: "Error:",
      OnbrdGenInputErrorMsg: "Please enter a value.",
      NAUplevelProgramType: "Please select your program type:",
      NAUplevelRetailSpecialization:
        "Please select your Retail Partner specialization:",
      OnbrdInterimSelectButton: "Select",

      OnbrdPartnerFinderInfoBusProfSection: "Business Profile",
      OnbrdPartnerFinderSSCountriesAmerica:
        "Sales/Support Countries/Regions (Americas)",
      OnbrdPartnerFinderSSCountriesEurope:
        "Sales/Support Countries/Regions (Europe/Asia)",
      OnbrdPartnerFinderSSCountriesAfrica:
        "Sales/Support Countries/Regions (Africa/ME)",
      OnbrdPartnerFinderSSCountiresAsia:
        "Sales/Support Countries/Regions (Asia Pacific)",
      OnbrdPartnerFinderBusinessDescEng:
        "Business Description (English) [Max: 255 Characters]",
      OnbrdLengthValidationErrorMsg:
        "Please enter a maximum of 255 characters.",
      OnbrdPartnerFinderAltLang: "Alternative Language",
      OnbrdPartnerFinderBusinessDescOther:
        "Business Description (Other Language) [Max: 255 Characters]",
      OnbrdPartnerFinderOrgSizeSection: "Organisation's Size",
      OnbrdPartnerFinderTotalEmp: "Total Employees",
      OnbrdPartnerFinderTotInsideTelSFDC: "Total Inside/Telephone Salesforce",
      OnbrdPartnerFinderTotOutsideDirSFDC: "Total Outside/Direct Salesforce",
      OnbrdPartnerFinderTotTechProfOnStaff:
        "Total Technical Professionals Onstaff",
      OnbrdPartnerFinderTotDevOnStaff: "Total Developers Onstaff",
      OnbrdPartnerFinderTotMarkProfOnStaff:
        "Total Marketing Professionals Onstaff",
      OnbrdPartnerFinderCustSegmentSection: "Customer Segments",
      OnbrdPartnerFinderPrimFocus: "Primary Focus",
      OnbrdGenErrorLabel: "Error:",
      AcctCustomerSegmentErrorMsg:
        "Selected value must be unique within the Customer Segment group.",
      OnbrdPartnerFinderSecFocus: "Secondary Focus",
      OnbrdPartnerFinderNotSig: "Not Significant",
      OnbrdPartnerFinderProdExpSection: "Product Expertise",
      OnbrdPartnerFinderProdExpAdobe: "Product Expertise - Adobe",
      OnbrdPartnerFinderProdExpOther:
        "Product Expertise - Other [Max: 255 Characters]",
      OnbrdPartnerFinderProductSoldSection: "Products Currently Sold",
      OnbrdPartnerFinderProdSoldAdobe: "Products Sold - Adobe",
      OnbrdPartnerFinderProdExpSoldOther:
        "Product Expertise Sold - Other [Max: 255 Characters]",
      OnbrdPartnerFinderSrvcOfferedSection: "Services Offered",
      AcctServicesOfferedErrorMsg:
        "Selected value must be unique within the Services Offered group.",
      OnbrdPartnerFinderVerticalFocusSection: "Vertical Focus",
      OnbrdPartnerFinderVertGovError:
        "You cannot select Government because you answered No to the compliance question asking if you sold  to Government customers.",
      OnbrdPartnerFinderVertEducError:
        "You cannot select Education  because you answered No to the compliance question asking if you sold  to Education customers.",
      AcctVerticalSegmentErrorMsg:
        "Selected value must be unique within the Vertical Segment group.",
      ctr1_certified:
        "Reseller must complete this online enrollment and accept the Reseller Program terms and conditions.",
      ctr2_certified:
        "Reseller must meet all of the criteria for the desired level. See the Adobe Partner Connection Reseller Program Guide for a complete list of requirements.",
      ctr1_gold:
        "Reseller must complete this online enrollment and accept the Reseller Program terms and conditions.",
      ctr2_gold:
        "Reseller must meet all of the criteria for the desired level. See the Adobe Partner Connection Reseller Program Guide for a complete list of requirements.",

      select_level: "Select Level",
      basic_comp_info: "Basic Company Info",
      location: "Location",
      comp_email_address: "Company E-mail Address *",
      i_certify: "I certify that I am either:",
      msg_saving_data: "Saving your form data",
      msg_data_saved: "Your data has been saved.",
      save_n_exit_body:
        "Feel free to return when you're ready to complete the enrollment process. You'll be returned to right were you left off. You can now close this browser window or navigate to another website.",
      contact_type: "Contact Type(select all that apply) *",
      confirm_deletion: "Confirm Deletion",
      delete_confirm_msg: "Are you sure you want to delete the contact :",
      delete_confirm_msg1: "?",
      prog_agmt_text:
        "We're almost done. The last step is to read the Partner Connection Program reseller agreement. Confirm your acceptance where indicated.",
      add: "Add",
      Select: "Select",
      select_all_that_apply: "Select all that apply",
      add_certified_contacts: "Add Certified Contacts",
      add_certified_msg:
        "Add details for a certified contacts below. Then click save.",
      course_completed: "Training Courses Completed",
      course_completed_COC: "Partner Code of Conduct - Status",
      errorForNoCOC_1:
        "At least one person must complete the Partner Code of Conduct training to proceed with the application. For completing the training, please Open ",
      errorForNoCOC_2: "Adobe Channel training Centre",
      errorForNoCOC_3:
        " using the link provided below the table. Once you complete the training, please click on the REFRESH button to refresh the course completion status of contacts.",
      logInCPButton: "Log in to Captivate Prime",
      refresh: "Refresh",
      course_completed_ff: "Training Courses Completed(select all that apply)",
      Register: "Register",
      "Contact Helpdesk": "Contact Helpdesk",

      prog_agmt_checkbox:
        "I HAVE READ, UNDERSTOOD, AND AGREED TO COMPLY WITH THE TERMS AND CONDITIONS INDICATED HEREIN AND REPRESENT AND WARRANT THAT I AM AUTHORIZED TO BIND THE RESELLER.",
      ReAssignContactNameLabel: "Contact Name",
      OnbrdPrimaryQuestionnaireSectionHeader:
        "Please answer the following questions about your organisation.",
      ConsolePartnerAccountListPartnerFinder: "List in Partner Finder?",
      ConsolePartnerContactHeader: "Contacts",

      thank_you: "Thank You!",
      ConsolePartnerConActive: "Active",
      Return_to_Adobe_Channel_Partners: "Adobe Partner Connection",
      "Continue Enrollment": "Continue Enrollment",
      problem_header: "There was a problem.",
      sign_in: "Sign in with Adobe ID",
      associated_other_account:
        "The Adobe ID you've signed in with (%{email}) is already associated with another Adobe Partner program: %{program}. You can sign in with another Adobe ID, or you can contact the helpdesk to continue your registration.",
      OnbrdGenInvalidTokenErrMsg:
        "Your link is already expired. Please call help desk.",
    },
  },
  fr_FR: {
    uplevelRenewal: {
      PP_Adobe_Portal: null,
      PP_APC_Header_Label: null,
      ONBUplevelInfo: "Veuillez s\u00e9lectionner le niveau souhait\u00e9.",
      ONBNewLevel: "Nouveau niveau",
      OnbrdInterimUplevelHeader:
        "S\u00e9lectionnez le niveau auquel vous souhaitez adh\u00e9rer.",
      OnbrdGenCertifiedLevel: null,
      OnbrdGenGoldLevel: null,
      OnbrdGenErrorLabel: "Erreur :",
      OnbrdGenInputErrorMsg: "Veuillez indiquer une valeur.",
      NAUplevelProgramType: null,
      NAUplevelRetailSpecialization: null,
      OnbrdInterimSelectButton: "S\u00e9lectionner",

      ctr1_certified:
        "Le partenaire doit remplir ce formulaire d'inscription en ligne et accepter les Termes et Conditions générales du Reseller Program.",
      ctr2_certified:
        "Le partenaire doit remplir tous les critères requis pour le niveau demandé. Pour obtenir la liste complète de ces critères, consultez le Guide du programme Adobe Reseller Partner Connection.",
      ctr1_gold:
        "Le partenaire doit remplir ce formulaire d'inscription en ligne et accepter les Termes et Conditions générales du Reseller Program.",
      ctr2_gold:
        "Le partenaire doit remplir tous les critères requis pour le niveau demandé. Pour obtenir la liste complète de ces critères, consultez le Guide du programme Adobe Reseller Partner Connection.",

      PP_APC_Header_Label: null,
      OnbrdCriteriaAuthoriseMsg:
        "Confirmez que vous êtes autorisés à répondre à ce questionnaire au nom de votre organisation en activant la case à cocher à l'endroit indiqué.",
      OnbrdTermsPartnerCodeMsg:
        "Consultez les conditions générales et le code de conduite des partenaires commerciaux d'Adobe et confirmez votre acceptation en activant la case à cocher à l'endroit indiqué.",
      OnbrdContactPrefLang: "Langue choisie *",
      PP_Adobe_Portal: null,
      ONBLangPref: "Zone géographique et langue",
      OnbrdCriteriaHeader: "Critères d'adhésion",
      OnbrdCriteriaHeaderRenewal: "Critères de renouvellement",
      OnbrdCriteriaHeaderUplevel: "Critères de passage à un niveau supérieur",
      ONBCompInfo: "Informations sur la société",
      ONBContsInfo: "Coordonnées",
      SplznQuestionnaireHeader: "Questionnaire",
      ONBPgmAgreement: "Contrat du programme",
      ONBPreferredLanguage:
        "Veuillez sélectionner le pays de votre entreprise et la langue de votre choix.",
      OnbrdProfileRegion: "Région",
      OnbrdGenSelectErrorMsg: "Veuille sélectionner une valeur.",
      OnbrdProfileCountry: "Pays",
      OnbrdGenNone: "--Aucune--",
      ONBRegCriteriaAgree:
        "Veuillez consulter les critères d'adhésion et confirmer votre accord.",
      OnbrdCriteriaBody:
        "Nous vous remercions de l'intérêt que vous portez à Adobe Partner Connection Reseller Program.",
      OnbrdCriteriaBodyRenewal:
        "Nous vous remercions pour votre demande de renouvellement d'adhésion à Adobe Partner Connection Reseller Program.",
      OnbrdCriteriaBodyUplevel:
        "Nous vous remercions de l'intérêt que vous portez aux niveaux supérieurs de Adobe Partner Connection Reseller Program.",
      OnbrdCriteriaBody1:
        "La procédure d'adhésion commence par cette inscription en ligne. Veuillez consulter les conditions d'accès au niveau souhaité du Reseller Program et les critères d'adhésion ci-dessous. Vérifiez ensuite que vous êtes autorisés à répondre à ce questionnaire, puis cliquez sur Suivant.",
      OnbrdCriteriaSectionHeader: "Critères d'adhésion",
      OnbrdCriteriaSectionHeaderRenewal: "CRITÈRES DE RENOUVELLEMENT",
      OnbrdCriteriaSectionHeaderUplevel:
        "CRITÈRES DE PASSAGE À UN NIVEAU SUPÉRIEUR",
      OnbrdCriteriaAuthorized:
        "membre de la direction ou directeur de l’organisation",
      OnbrdCriteriaAuthorized2:
        "une personne autorisée à répondre à ce questionnaire au nom de l’organisation",
      ONBEnterCompDetails:
        "Veuillez fournir les informations suivantes sur votre société.",
      OnbrdProfileMembershipId: "ID d'adhérent",
      OnbrdProfileParentMembershipId: "Numéro de l'adhérent parent",
      OnbrdProfileContractStart: "Date de début de contrat",
      OnbrdProfilePartnerLevel: "Niveau de partenariat",
      OnbrdProfileContractEnd: "Date de fin de contrat",
      OnbrdProfileSplzn: "Informations sur le spécialiste",
      OnbrdProfileAcctMgr: "Responsable des comptes",
      OnbrdProfileAddLicenses: "Nombre de licences supplémentaires",
      OnbrdProfileFullCompName: "Nom complet de la société",
      OnbrdGenInputErrorMsg: "Veuillez indiquer une valeur.",
      OnbrdProfileTradingName: "Raison commerciale",
      OnbrdProfileBRN: "Numéro SIRET",
      OnbrdProfilePreferredDistributor: "Distributeur favori",
      OnbrdProfileYrIncorp: "Année de constitution de la société *",
      OnbrdGenInvalidYrFormat: "S'il vous plaît suivre le format: YYYY",
      OnbrdGenInvalidYr: "Année n'est pas valide.",
      OnbrdGenInvalidFutureDateMsg: null,
      OnbrdProfileCompType: "Type de société (Plusieurs réponses possibles) *",
      OnbrdProfileStreet: "Rue *",
      OnbrdProfileCity: "Ville *",
      OnbrdProfileState: "État/Province *",
      OnbrdProfilePostCode: "Code postal *",
      OnbrdProfilePrimPhone: "Num.Téléphone Principal *",
      OnbrdProfilePrimFax: "Num.Fax Principal",
      OnbrdProfileContactEmail: "E-mail *",
      OnbrdGenEmailFormatErrMsg: "Format de courrier électronique incorrect",
      OnbrdProfileCompanyDomainMsg:
        "Le domaine de la société spécifié ne correspond pas à celui du contact principal.",
      OnbrdProfileEmailDomain: "Extension d’email",
      OnbrdProfilePrimURL: "Site web *",
      OnbrdProfileSecondaryURL: "Site web secondaire",
      OnbrdProfileListPartnerFinder: "Figurer dans l'annuaire des revendeurs ?",
      ONBContactDetails:
        "Veuillez fournir les coordonnées des contacts de votre société.",
      OnbrdContactSecContactInfo: "Contacts",
      OnbrdContactSectionHeader:
        "REMARQUE : Vous devez spécifier des contacts principaux et secondaires. Vous pouvez ajouter d'autres contacts susceptibles de nous fournir des renseignements commerciaux, de marketing et techniques.",
      ONBAddSecBtn: "Ajouter le contact secondaire",
      ONBAddOtherBtn: "Ajouter un autre contact",
      ReAssignContactNameLabel: "Nom du contact",
      ConsolePartnerContactEmail: "E-mail",
      ConsolePartnerContactCType: "Type du contact principal",
      TrngManage: "Gérer",
      OnbrdContactPrimaryType: "Principal",
      OnbrdContactSecondaryType: "Second",
      OnbrdContactOtherType: "Autres",
      ConsolePartnerBtnEdit: "Modifier",
      QBPDelete: "Supprimer",
      OnbrdContactPriConHeader: "Contact Principal",
      OnbrdContactSecConHeader: "Contact Secondaire",
      OnbrdContactOther: "Autres contacts",
      OnbrdContactPrefix: "Préfixe",
      OnbrdContactTitle: "Suffixe/Titre",
      prefixMaxLengthError:
        "Prefix must be 10 characters or fewer, Kindly update.",
      suffixMaxLengthError:
        "Suffix must be 10 characters or fewer, Kindly update.",
      OnbrdContactFName: "Prénom *",
      OnbrdContactLName: "Nom *",
      OnbrdContactPhone: "Téléphone *",
      OnbrdContactJRole: "Fonction *",
      OnbrdContactEmail: "E-mail *",
      OnbrdContactAddtlType: "Type",
      OnbrdContactDeactivate: "Désactiver",
      OnbrdContactDeactivateHelp:
        "L'activation de la case à cocher DÉSACTIVER supprimera le contact du compte et l'empêchera d'accéder aux systèmes Adobe.",
      TrngSaveClose: "Enregistrer et fermer",
      TrngClose: "Fermer",
      ONBRegCerContacts:
        "Please select and complete the required COC training course before submitting your request.",
      OnbrdCertContactSectionHeader:
        "Une formation à la vente est nécessaire pour accéder au niveau souhaité. Une personne au moins doit suivre la formation « Code de conduite des partenaires ». Pour obtenir la liste complète des formations requises, consultez le Guide du programme Revendeurs ou Détaillants d’Adobe Partner Connection. Dans les champs ci-dessous, indiquez les contacts ayant suivi la formation requise.",
      OnbrdContactAdd: "Ajouter un contact",
      OnbrdCertContactFName: "Prénom",
      OnbrdCertContactLName: "Nom",
      OnbrdCertContactEmail: "E-mail",
      OnbrdCertContactCertification: "COURS DE FORMATION TERMINÉ",
      TrngManage: "Gérer",
      ConsolePartnerBtnEdit: "Modifier",
      ONBCerContactDetails: "Détails du contact certifié",
      OnbrdCertContactDeactivated: "DÉSACTIVER",
      ONBRetailSplQues:
        "Questionnaire de spécialisation du programme de vente au détail",
      OnbrdPrimaryQuestionnaireHeader:
        "Questionnaire sur le respect des conditions d'adhésion",
      OnbrdSecondaryQuestionnaireHeader: "Second questionnaire d'adhésion",
      OnbrdPartnerFinderInfoHeader:
        "Questionnaire sur l'inscription de l’organisation",
      ONBAgreeToSubmit:
        "Veuillez consulter le contrat du programme et confirmer votre accord.",
      OnbrdTermsSectionHeader2:
        "Veuiller revoir les Termes et Conditions du Reseller Program. Vous devrez  descendre au bas de la page pour confirmer/accepter.",
      OnbrdTermsSectionHeader: "Conditions générales",
      OnbrdTermsAccept:
        "J'AI LU, COMPRIS ET ACCEPTÉ L’ENSEMBLE DES CONDITIONS SUSVISÉES ET JE DÉCLARE ET GARANTIS QUE JE SUIS HABILITÉ À REPRESENTER MA SOCIETE.",
      OnbrdThankYouNewRegistered:
        "Nous vous remercions de l'intérêt que vous portez à Adobe Partner Connection. Nous avons bien reçu votre dossier de candidature. Vous recevrez très prochainement un e-mail de confirmation. Nous vous tiendrons régulièrement informé par e-mail de la suite donnée à votre dossier.",
      OnbrdThankYouRenewalRegistered:
        "Votre demande de renouvellement est enregistrée; vous recevrez très prochainement un e-mail de confirmation. Nous vous tiendrons régulièrement informé par e-mail de la suite donnée à votre dossier.",
      OnbrdThankYouRenewalCertGold:
        "Votre demande de renouvellement est enregistrée; vous recevrez très prochainement un e-mail de confirmation. Nous vous tiendrons régulièrement informé par e-mail de la suite donnée à votre dossier.",
      OnbrdThankYouUplevelCertGold:
        "Nous vous remercions de l'intérêt que vous portez aux niveaux supérieurs du programme Revendeurs Adobe Partner Connection. Nous avons bien reçu votre demande d'adhésion à un niveau supérieur. Vous recevrez très prochainement un e-mail de confirmation. Nous vous tiendrons régulièrement informé par e-mail de la suite donnée à votre dossier.",
      OnbrdThankYouClick: "Cliquez",
      OnbrdThankYouEducURL:
        "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=Education&id=",
      OnbrdThankYouHere: "ici",
      OnbrdThankYouEd: "pour renouveler votre spécialisation Éducation.",
      OnbrdThankYouLegalURL:
        "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=SAM+services&id=",
      OnbrdThankYouLeg: "pour renouveler votre spécialisation Services SAM.",
      OnbrdThankYouProVedioURL:
        "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=ProVideo&id=",
      OnbrdThankYouPv: "pour renouveler votre spécialisation ProVideo.",
      OnbrdThankYouGovURL:
        "http://adobedealreg.sfqa.cs12.force.com/Onboarding/SplznWizardPage?sp=Government&id=",
      OnbrdThankYouGv: null,
      OnbrdThankYouDpsURL:
        "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=DigitalPublishingSuite&id=",
      OnbrdThankYouDps: null,
      OnbrdThankYouHelpDesk:
        "Pour toute question sur Reseller Program ou votre candidature, contactez le service Adobe Partner Connection Help Desk",
      OnbrdErrorUnauthorized:
        "Désolé, vous n'êtes pas autorisé à consulter la page. Contactez le service d'assistance du programme en partenariat pour obtenir de l'aide sur le processus d'adhésion/de passage à un niveau supérieur.",
      OnbrdErrorNewRegEmailExist:
        "<br/><br/>\n<p>Votre demande d'adhésion n'a pas pu être traitée car votre adresse électronique existe déjà dans le système.</p>\n<br/><br/><br/><br/><br/>",
      OnbrdErrorNewRegEmailFree:
        "<br/><br/> \n<p>Les FAI et domaines de messagerie gratuits ne peuvent pas être utilisés en tant que domaines du contact principal et de la société. Inscrivez-vous pour obtenir un identifiant Adobe et ouvrir un compte de messagerie professionnelle.</p> \n<br/><br/><br/><br/><br/>",
      OnbrdErrorExpiredLink:
        "<br/><br/>\n<p>Votre lien a déjà expiré. Merci de contacter le service Adobe Partner Connection Help Desk.</p>\n<br/><br/><br/><br/><br/>",
      OnbrdInterimUplevelExistsMsg:
        "Nous vous remercions de l'intérêt que vous portez aux niveaux supérieurs du programme Adobe Partner Connection. Nous étudions actuellement déjà une demande de votre part pour adhérer à ce niveau. Nous vous tiendrons informé par e-mail de la suite donnée à votre dossier.",
      OnbrdProgNextStepExistMsg:
        "Ce revendeur est déjà inscrit au programme Revendeurs Adobe Partner Connection. Vous pouvez l'informer de votre souhait de participer au programme en cliquant ci-dessous sur le bouton Envoyer un e-mail.",
      OnbrdGenPreviousLabel: "Précédent",
      OnbrdGenSaveExitLabel: "Enregistrer et quitter",
      OnbrdGenSubmitLabel: "Envoyer",
      OnbrdGenNextLabel: "Suivant",
      OnbrdPartnerFinderProdExpOther:
        "Expertise produit – Autre[255 caractères maximum]",
      OnbrdPrimaryQuestionnaireSectionHeader:
        "Veuillez fournir les informations suivantes sur votre organisation.",
      renewal_unauthorized:
        "Désolé, vous n'êtes pas autorisé à consulter la page.",

      OnbrdPartnerFinderInfoBusProfSection: "Profil de l’organisation",
      OnbrdPartnerFinderSSCountriesAmerica:
        "Vente et Assistance à d’autres pais( Amerique)",
      OnbrdPartnerFinderSSCountriesEurope:
        "Vente et Assistance à d’autres pais( Europe et Asie Centrale)",
      OnbrdPartnerFinderSSCountriesAfrica:
        "Vente et Assistance à d’autres pais( Afrique et Moyen Orient)",
      OnbrdPartnerFinderSSCountiresAsia:
        "Vente et Assistance à d’autres pais( Asie Pacifique)",
      OnbrdPartnerFinderBusinessDescEng:
        "Anglais pour la description de l'activité",
      OnbrdLengthValidationErrorMsg:
        "Veuillez entrer un maximum de 255 caractères.",
      OnbrdPartnerFinderAltLang: "Autre langue",
      OnbrdPartnerFinderBusinessDescOther:
        "Autre langue pour la description de l'activité",
      OnbrdPartnerFinderOrgSizeSection: "Taille de l’organisation",
      OnbrdPartnerFinderTotalEmp: "Nombre total d’ employés",
      OnbrdPartnerFinderTotInsideTelSFDC:
        "Nombre total de commerciaux (internes/téléphone)",
      OnbrdPartnerFinderTotOutsideDirSFDC:
        "Nombre total de commerciaux (itinérants/directs)",
      OnbrdPartnerFinderTotTechProfOnStaff: "Nombre de techniciens employés",
      OnbrdPartnerFinderTotDevOnStaff: "Nombre de développeurs employés",
      OnbrdPartnerFinderTotMarkProfOnStaff:
        "Nombre de professionnels du marketing employés",
      OnbrdPartnerFinderCustSegmentSection: "Segment de clientèle",
      OnbrdPartnerFinderPrimFocus: "Objectif principal",
      OnbrdGenErrorLabel: "Erreur :",
      AcctCustomerSegmentErrorMsg:
        "La valeur sélectionnée doit être unique au sein du groupe Segment de clientèle.",
      OnbrdPartnerFinderSecFocus: "Objectif secondaire",
      OnbrdPartnerFinderNotSig: "Non significatif",
      OnbrdPartnerFinderProdExpSection: "Expertise produit",
      OnbrdPartnerFinderProdExpAdobe: "Expertise produit – Adobe",
      OnbrdPartnerFinderProdExpOther:
        "Expertise produit – Autre[255 caractères maximum]",
      OnbrdPartnerFinderProductSoldSection: "Produits actuellement proposés",
      OnbrdPartnerFinderProdSoldAdobe: "Produits vendus - Adobe",
      OnbrdPartnerFinderProdExpSoldOther:
        "Produits vendus - Autre[255 caractères maximum]",
      OnbrdPartnerFinderSrvcOfferedSection: "Services offerts",
      AcctServicesOfferedErrorMsg:
        "La valeur sélectionnée doit être unique au sein du groupe Services offerts.",
      OnbrdPartnerFinderVerticalFocusSection: "Marchés verticaux",
      OnbrdPartnerFinderVertGovError:
        "Vous ne pouvez sélectionner l'option Gouvernement car vous avez repondu NON aux questions préalables sur la revente aux clients Gouvernement.",
      OnbrdPartnerFinderVertEducError:
        "Vous ne pouvez sélectionner l'option Education car vous avez repondu NON aux questions préalables sur la revente aux clients Education.",
      AcctVerticalSegmentErrorMsg:
        "La valeur sélectionnée doit être unique au sein du groupe Segment vertical.",
      Previous: "Précédent",
      "Save and Exit": "Enregistrer et quitter",
      Submit: "Envoyer",
      Next: "Suivant",

      select_level: "Sélectionner un niveau",
      basic_comp_info: "Informations générales sur l'entreprise",
      location: "Lieu",
      comp_email_address: "Adresse e-mail de l'entreprise *",
      i_certify: "Je certifie que je remplis l'une des conditions ci-dessous :",
      msg_saving_data: "Enregistrement des données du formulaire",
      msg_data_saved: "Vos données sont enregistrées.",
      save_n_exit_body:
        "Vous pouvez reprendre à tout moment le processus d'adhésion, exactement là où vous vous êtes arrêté. À présent, vous pouvez fermer la fenêtre de votre navigateur ou ouvrir un autre site web.",
      contact_type: "Type de contact (Plusieurs réponses possibles) *",
      confirm_deletion: "Confirmar eliminación",
      delete_confirm_msg:
        "Voulez-vous vraiment supprimer le contact suivant : ",
      delete_confirm_msg1: "?",
      prog_agmt_text:
        "Nous avons presque terminé. En dernier lieu, nous vous invitons à lire le contrat du programme Partner Connection. Suivez les indications à l'écran pour confirmer votre accord.",
      Select: "Seleccionar",
      select_all_that_apply: "Plusieurs réponses possibles",
      add_certified_contacts: "Ajouter des contacts certifiés",
      add_certified_msg:
        "Ajoutez ci-dessous les coordonnées d'un contact certifié. Cliquez ensuite sur Enregistrer.",
      course_completed: "Cours de formation terminés ",
      course_completed_COC: "Code de Conduite des Partenaires - Statut",
      errorForNoCOC_1:
        "Au moins une personne doit suivre la formation sur le code de conduite des partenaires pour pouvoir procéder à la demande. Pour compléter la formation, veuillez ouvrir le ",
      errorForNoCOC_2: "centre de formation Adobe Channel",
      errorForNoCOC_3:
        " en utilisant le lien fourni sous le tableau. Une fois que vous avez terminé la formation, veuillez cliquer sur le bouton REFRESH pour rafraîchir l'état d'achèvement de la formation des contacts.",
      logInCPButton: "Allez sur Captivate Prime",
      refresh: "Rafraîchir",
      course_completed_ff:
        "Cours de formation terminés (Plusieurs réponses possibles)",
      Register: "S’inscrire",
      "Contact Helpdesk": "Contacter l'assistance",

      prog_agmt_checkbox:
        "J'AI LU, COMPRIS ET ACCEPTÉ L’ENSEMBLE DES CONDITIONS SUSVISÉES ET JE DÉCLARE ET GARANTIS QUE JE SUIS HABILITÉ À REPRESENTER MA SOCIETE.",
      ConsolePartnerAccountListPartnerFinder:
        "Figurer dans l'annuaire des revendeurs (?)",
      ConsolePartnerContactHeader: "Contacts",

      thank_you: "Merci.",
      ConsolePartnerConActive: "Actif",
      Return_to_Adobe_Channel_Partners: "Adobe Partner Connection",
      "Continue Enrollment": "Continuer l'inscription",
      problem_header: "Une erreur est survenue.",
      sign_in: "Connexion avec un Adobe ID",
      associated_other_account:
        "L'Adobe ID que vous avez saisi (%{email}) est déjà associé à un autre programme partenaire Adobe: %{program}. Connectez-vous avec un autre Adobe ID ou contactez notre assistance.",
      OnbrdGenInvalidTokenErrMsg:
        "Votre lien a déjà expiré. Contactez le service d'assistance.",
    },
  },
  zh_CN: {
    uplevelRenewal: {
      PP_Adobe_Portal: "Adobe合作伙伴",
      PP_APC_Header_Label: "APC门户网站",
      ONBUplevelInfo: "请选择期望的级别。",
      ONBNewLevel: "新级别",
      OnbrdInterimUplevelHeader: "请选择您想要申请的会员级别。",
      OnbrdGenCertifiedLevel: "认证级别",
      OnbrdGenGoldLevel: "金牌",
      OnbrdGenErrorLabel: "错误：",
      OnbrdGenInputErrorMsg: "请输入值。",
      NAUplevelProgramType: null,
      NAUplevelRetailSpecialization: null,
      OnbrdInterimSelectButton: "选择",

      ctr1_certified: "经销商须完成此项在线注册并接受经销商项目的条款与条件。",
      ctr2_certified:
        "经销商须达到期望会员级别的所有标准。请阅读APC经销商项目指南，查看各种要求。",
      ctr1_gold: "经销商须完成此项在线注册并接受经销商项目的条款与条件。",
      ctr2_gold:
        "经销商须达到期望会员级别的所有标准。请阅读APC经销商项目指南，查看各种要求。",

      PP_APC_Header_Label: "APC门户网站",
      OnbrdCriteriaAuthoriseMsg:
        "请勾选提示之处，确认您有权代表贵组织完成此次申请。",
      OnbrdTermsPartnerCodeMsg:
        "请查看这些条款与条件以及Adobe商业合作伙伴行为准则，勾选提示之处以确认接受。",
      OnbrdContactPrefLang: "首选语言 *",
      PP_Adobe_Portal: "Adobe合作伙伴",
      ONBLangPref: "地区与语言",
      OnbrdCriteriaHeader: "注册标准",
      OnbrdCriteriaHeaderRenewal: "续订标准",
      OnbrdCriteriaHeaderUplevel: "升级标准",
      ONBCompInfo: "公司信息",
      ONBContsInfo: "联系信息",
      SplznQuestionnaireHeader: "调查问卷",
      ONBPgmAgreement: "计划协议",
      ONBPreferredLanguage: "请选择贵组织的位置及您的首选语言。",
      OnbrdProfileRegion: "地区",
      OnbrdGenSelectErrorMsg: "请选择值。",
      OnbrdProfileCountry: "国家/地区",
      OnbrdGenNone: "--无--",
      ONBRegCriteriaAgree: "请查看注册标准并表明您接受该标准。",
      OnbrdCriteriaBody: "感谢您关注APC经销商项目。",
      OnbrdCriteriaBodyRenewal: "感谢您有意续订APC经销商项目会籍。",
      OnbrdCriteriaBodyUplevel: "感谢您有意升级APC经销商项目会籍。",
      OnbrdCriteriaBody1:
        "要想成为会员，您必须首先完成此在线注册。请查看期望会员等级的经销商计划要求以及下列注册标准。当您准备开始操作时，请确认您有权完成此次申请。之后，请点击“下一步”继续。",
      OnbrdCriteriaSectionHeader: "注册标准",
      OnbrdCriteriaSectionHeaderRenewal: "续订标准",
      OnbrdCriteriaSectionHeaderUplevel: "升级标准",
      OnbrdCriteriaAuthorized: "是公司的主管或总监，或者",
      OnbrdCriteriaAuthorized2:
        "得到主管或总监的明确授权，可以代表公司完成本次申请。",
      ONBEnterCompDetails: "请提供有关贵组织的以下信息。",
      OnbrdProfileMembershipId: "会员ID",
      OnbrdProfileParentMembershipId: "父会员ID",
      OnbrdProfileContractStart: "合同起始日期",
      OnbrdProfilePartnerLevel: "合作伙伴级别",
      OnbrdProfileContractEnd: "合同终止日期",
      OnbrdProfileSplzn: "专业化认证",
      OnbrdProfileAcctMgr: "客户经理",
      OnbrdProfileAddLicenses: "# 其他许可证",
      OnbrdProfileFullCompName: "公司全称",
      OnbrdGenInputErrorMsg: "请输入值。",
      OnbrdProfileTradingName: "中文公司名称",
      OnbrdProfileBRN: "商业注册号码",
      OnbrdProfilePreferredDistributor: "首选经销商",
      OnbrdProfileYrIncorp: "成立年份 *",
      OnbrdGenInvalidYrFormat: "请按照以下格式填写年份：YYYY",
      OnbrdGenInvalidYr: "年份无效。",
      OnbrdGenInvalidFutureDateMsg: "设置未来的日期。请输入有效的日期。",
      OnbrdProfileCompType: "公司类型 (选择所有适用的选项) *",
      OnbrdProfileStreet: "街道 *",
      OnbrdProfileCity: "城市 *",
      OnbrdProfileState: "州/省 *",
      OnbrdProfilePostCode: "邮政编码 *",
      OnbrdProfilePrimPhone: "首选电话 *",
      OnbrdProfilePrimFax: "首选传真",
      OnbrdProfileContactEmail: "电子邮件地址 *",
      OnbrdGenEmailFormatErrMsg: "电子邮件格式无效。",
      OnbrdProfileCompanyDomainMsg:
        "您输入的公司电子邮件网络域名与第一联系人的电子邮件网络域名不相符。",
      OnbrdProfileEmailDomain: "电子邮件网络域名",
      OnbrdProfilePrimURL: "网站 *",
      OnbrdProfileSecondaryURL: "二级网站",
      OnbrdProfileListPartnerFinder: "在经销商查找器中列出？",
      ONBContactDetails: "请提供贵组织的联系信息。",
      OnbrdContactSecContactInfo: "联系信息",
      OnbrdContactSectionHeader:
        "请提供贵组织的联系信息。<br/>\n注意：必须提供第一和第二联系人。您可以添加更多联系人，以便我们与您联系探讨销售、营销和技术方面的最新进展。",
      ONBAddSecBtn: "添加第二联系人",
      ONBAddOtherBtn: "添加其他",
      ReAssignContactNameLabel: "联系人姓名",
      ConsolePartnerContactEmail: "电子邮件",
      ConsolePartnerContactCType: "主要联系方式",
      TrngManage: "管理",
      OnbrdContactPrimaryType: "第一",
      OnbrdContactSecondaryType: "第二",
      OnbrdContactOtherType: "其它",
      ConsolePartnerBtnEdit: "编辑",
      QBPDelete: "删除",
      OnbrdContactPriConHeader: "第一联系人",
      OnbrdContactSecConHeader: "第二联系人",
      OnbrdContactOther: "其他联系人",
      OnbrdContactPrefix: "前缀",
      OnbrdContactTitle: "后缀/职称",
      prefixMaxLengthError:
        "Prefix must be 10 characters or fewer, Kindly update.",
      suffixMaxLengthError:
        "Suffix must be 10 characters or fewer, Kindly update.",
      OnbrdContactFName: "名字 *",
      OnbrdContactLName: "姓氏 *",
      OnbrdContactPhone: "电话 *",
      OnbrdContactJRole: "工作职责 *",
      OnbrdContactEmail: "电子邮件 *",
      OnbrdContactAddtlType: "类型",
      OnbrdContactDeactivate: "取消激活",
      OnbrdContactDeactivateHelp:
        "勾选“取消激活”框将从帐户中删除此联系人。此联系人将不再享有Adobe系统的访问权。",
      TrngSaveClose: "保存并关闭",
      TrngClose: "关闭",
      ONBRegCerContacts:
        "Please select and complete the required COC training course before submitting your request.",
      OnbrdCertContactSectionHeader:
        "您想申请的会员级别要求经过销售培训。至少须一人完成“合作伙伴行为准则”培训。请阅读APC经销商项目指南，查看各种培训要求。请在下栏中指明已经完成必要培训的联系人。",
      OnbrdContactAdd: "添加另一位联系人",
      OnbrdCertContactFName: "名字",
      OnbrdCertContactLName: "姓氏",
      OnbrdCertContactEmail: "电子邮件",
      OnbrdCertContactCertification: "已完成的培训课程",
      TrngManage: "管理",
      ONBCerContactDetails: "认证联系人信息",
      OnbrdCertContactDeactivated: "取消激活",
      ONBRetailSplQues: null,
      OnbrdPrimaryQuestionnaireHeader: "注册合规调查问卷",
      OnbrdSecondaryQuestionnaireHeader: "注册二次调查问卷",
      OnbrdPartnerFinderInfoHeader: "注册业务调查问卷",
      ONBAgreeToSubmit: "请查看计划协议并表明您接受该协议。",
      OnbrdTermsSectionHeader2:
        "请查看经销商计划的条款与条件。您需要向下滚动，在提示之处确认接受。",
      OnbrdTermsSectionHeader: "条款与条件",
      OnbrdTermsAccept:
        "本人已经阅读、理解并同意遵守此处所示的条款与条件，本人声明并保证自己有权约束该经销商。",
      OnbrdThankYouNewRegistered:
        "<br/>\n感谢您关注APC经销商项目。您的申请已收悉。您将很快收到确认电子邮件。有关您的申请的任何最新信息，我们将继续通过电子邮件告知您。<br/><br/>",
      OnbrdThankYouRenewalRegistered:
        "您已提出续订，并将很快收到确认电子邮件。",
      OnbrdThankYouRenewalCertGold: "您已提出续订，并将很快收到确认电子邮件。",
      OnbrdThankYouUplevelCertGold:
        "感谢您有意升级APC经销商项目会籍。您的升级申请已收悉。您将很快收到确认电子邮件。有关您的申请的任何最新信息，我们将继续通过电子邮件告知您。",
      OnbrdThankYouClick: "点击",
      OnbrdThankYouEducURL:
        "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=Education&id=",
      OnbrdThankYouHere: "此处",
      OnbrdThankYouEd: "续订您的教育专业化认证。",
      OnbrdThankYouLegalURL:
        "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=SAM+services&id=",
      OnbrdThankYouLeg: "续订您的SAM服务专业化认证。",
      OnbrdThankYouProVedioURL:
        "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=ProVideo&id=",
      OnbrdThankYouPv: "续订您的ProVideo专业化认证。",
      OnbrdThankYouGovURL:
        "http://adobedealreg.sfqa.cs12.force.com/Onboarding/SplznWizardPage?sp=Government&id=",
      OnbrdThankYouGv: "续订您的政府专业化认证。",
      OnbrdThankYouDpsURL:
        "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=DigitalPublishingSuite&id=",
      OnbrdThankYouDps: "续订您的数字出版套件专业化认证",
      OnbrdThankYouHelpDesk: "如需帮助，请联系APC服务台。",
      OnbrdErrorUnauthorized:
        "抱歉，您无权查看该页面。请联系合作伙伴服务台寻求注册/升级帮助。",
      OnbrdErrorNewRegEmailExist:
        "<br/><br/>\n<p>系统中已有您的电子邮件地址，无法处理您的注册</p>\n<br/><br/><br/><br/><br/>",
      OnbrdErrorNewRegEmailFree:
        "<br/><br/>\n<p>不允许以免费电子邮件网络域名和互联网服务供应商 (ISP) 作为公司和第一联系人的电子邮件网络域名。请使用公司电子邮件帐户注册Adobe ID。</p> \n<br/><br/><br/><br/><br/>",
      OnbrdErrorExpiredLink:
        "<br/><br/>\n<p>您的链接已过期。请联系合作伙伴服务台。</p>\n<br/><br/><br/><br/><br/>",
      OnbrdInterimUplevelExistsMsg:
        "感谢您有意升级APC计划会籍。我们已经在审核之前提交的升级申请。有关您的申请的任何最新信息，我们将通过电子邮件告知您。",
      OnbrdProgNextStepExistMsg: "此经销商已注册加入APC计划。请联系APC服务台。",
      OnbrdGenPreviousLabel: "上一页",
      OnbrdGenSaveExitLabel: "保存并退出",
      OnbrdGenSubmitLabel: "提交",
      OnbrdGenNextLabel: "下一页",
      OnbrdPartnerFinderProdExpOther:
        "产品专业技术 - 其他[最大限制：255个字符]",
      OnbrdPrimaryQuestionnaireSectionHeader: "请回答有关贵组织的以下问题。",
      Previous: "上一页",
      "Save and Exit": "保存并退出",
      Submit: "提交",
      Next: "下一页",
      renewal_unauthorized: "抱歉，您无权查看该页面。",

      select_level: "选择级别",
      basic_comp_info: "基本公司信息",
      location: "地点",
      comp_email_address: "公司电子邮件地址 *",
      save_n_exit_body:
        "您可在准备好完成注册流程后随时返回。下次返回时您将从退出的位置继续。现在您可以关闭浏览器窗口或者导航到其他网站。",
      contact_type: "联系人类型 (选择所有适用的选项) *",
      confirm_deletion: "确认删除",
      delete_confirm_msg: "您是否确定要删除以下联系人：",
      delete_confirm_msg1: "?",
      prog_agmt_text:
        "此流程即将完成。最后一步是阅读合作伙伴联系计划经销商协议。在所示位置确认您接受该协议。",
      add: "添加",
      Select: "选择",
      select_all_that_apply: "选择所有适用的选项",
      i_certify: "我确认本人：",
      msg_saving_data: "保存表格数据",
      msg_data_saved: "您的数据已保存。",
      add_certified_contacts: "添加已认证联系人",
      add_certified_msg: "在下方添加已认证联系人的详细信息。然后单击“保存”。",
      course_completed: "培训课程已完成 ",
      course_completed_COC: "合作伙伴行为准则-状态",
      errorForNoCOC_1:
        "若要处理此申请，需至少有一个人完成代理商行为准则培训。请打开如下",
      errorForNoCOC_2: "Adobe Channel training Centre",
      errorForNoCOC_3:
        "链接并完成培训。完成培训后，请点击“刷新”按钮，随后页面将显示该联系人已完成此课程。",
      logInCPButton: "登录 Captivate Prime",
      refresh: "刷新",
      course_completed_ff: "培训课程已完成 (选择所有适用的选项)",
      Register: "注册",
      "Contact Helpdesk": "联系帮助中心",

      prog_agmt_checkbox:
        "本人已经阅读、理解并同意遵守此处所示的条款与条件，本人声明并保证自己有权约束该经销商。",
      ConsolePartnerAccountListPartnerFinder: "在合作伙伴查找器中列出(?)",
      ConsolePartnerContactHeader: "联系人",

      OnbrdPartnerFinderInfoBusProfSection: "业务资料",
      OnbrdPartnerFinderSSCountriesAmerica: "销售/支持国家/地区（美洲）",
      OnbrdPartnerFinderSSCountriesEurope: "销售/支持国家/地区（欧洲/亚洲）",
      OnbrdPartnerFinderSSCountriesAfrica: "销售/支持国家/地区（非洲/中东）",
      OnbrdPartnerFinderSSCountiresAsia: "销售/支持国家/地区（亚太地区）",
      OnbrdPartnerFinderBusinessDescEng:
        "业务描述（英文）[最大限制：255个字符]",
      OnbrdLengthValidationErrorMsg: "最多可输入255个字符。",
      OnbrdPartnerFinderAltLang: "替代语言",
      OnbrdPartnerFinderBusinessDescOther:
        "业务描述（其他语言）[最大限制：255个字符]",
      OnbrdPartnerFinderOrgSizeSection: "组织规模",
      OnbrdPartnerFinderTotalEmp: "员工总数",
      OnbrdPartnerFinderTotInsideTelSFDC: "内部/电话销售人员总数",
      OnbrdPartnerFinderTotOutsideDirSFDC: "外部/直销人员总数",
      OnbrdPartnerFinderTotTechProfOnStaff: "在职技术人员总数",
      OnbrdPartnerFinderTotDevOnStaff: "在职开发人员总数",
      OnbrdPartnerFinderTotMarkProfOnStaff: "在职营销人员总数",
      OnbrdPartnerFinderCustSegmentSection: "客户群",
      OnbrdPartnerFinderPrimFocus: "首要焦点",
      OnbrdGenErrorLabel: "错误：",
      AcctCustomerSegmentErrorMsg: "选定值必须在客户细分群组中独一无二。",
      OnbrdPartnerFinderSecFocus: "次要焦点",
      OnbrdPartnerFinderNotSig: "不重要",
      OnbrdPartnerFinderProdExpSection: "产品专业技术",
      OnbrdPartnerFinderProdExpAdobe: "产品专业技术 - Adobe",
      OnbrdPartnerFinderProdExpOther:
        "产品专业技术 - 其他[最大限制：255个字符]",
      OnbrdPartnerFinderProductSoldSection: "目前已售出的产品",
      OnbrdPartnerFinderProdSoldAdobe: "已售出的产品 - Adobe",
      OnbrdPartnerFinderProdExpSoldOther:
        "已售出的产品专业技术 - 其他[最大限制：255个字符]",
      OnbrdPartnerFinderSrvcOfferedSection: "提供的服务",
      AcctServicesOfferedErrorMsg: "选定值必须在提供的服务群组中独一无二。",
      OnbrdPartnerFinderVerticalFocusSection: "垂直行业焦点",
      OnbrdPartnerFinderVertGovError:
        "因为对于是否曾经向政府客户销售产品的合规问题，您回答了“否”，所以无法选择“政府”。",
      OnbrdPartnerFinderVertEducError:
        "因为对于是否曾经向教育行业客户销售产品的合规问题，您回答了“否”，所以无法选择“教育”。",
      AcctVerticalSegmentErrorMsg: "选定值必须在垂直细分群组中独一无二。",

      thank_you: "非常感谢。",
      ConsolePartnerConActive: "活跃",
      Return_to_Adobe_Channel_Partners: "Adobe Partner Connection",
      "Continue Enrollment": "Continue Enrollment",
      problem_header: "出现问题。",
      sign_in: "使用 Adobe ID 登录",
      associated_other_account:
        "您登录时使用的 Adobe ID (%{email}) 已与其他 Adobe 合作伙伴计划关联：%{program}。您可以使用其他 Adobe ID 或联系帮助台以继续完成注册流程。",
      OnbrdGenInvalidTokenErrMsg: "您的链接已过期。请致电服务台。",
    },
  },
  de_DE: {
    uplevelRenewal: {
      PP_Adobe_Portal: null,
      PP_APC_Header_Label: null,
      ONBUplevelInfo: "Geben Sie die gew\u00fcnschte Stufe an.",
      ONBNewLevel: "Neue Stufe",
      OnbrdInterimUplevelHeader:
        "Bitte w\u00e4hlen Sie die Stufe, die Sie beantragen m\u00f6chten.",
      OnbrdGenCertifiedLevel: null,
      OnbrdGenGoldLevel: null,
      OnbrdGenErrorLabel: "Fehler:",
      OnbrdGenInputErrorMsg: "Geben Sie einen Wert ein.",
      NAUplevelProgramType: null,
      NAUplevelRetailSpecialization: null,
      OnbrdInterimSelectButton: "Ausw\u00e4hlen",

      ctr1_certified:
        "Der Fachhändler füllt das vorliegende Online-Anmeldeformular aus und akzeptiert die Bedingungen des Reseller Program.",
      ctr2_certified:
        "Der Fachhändler erfüllt alle Anforderungen für die gewünschte Mitgliedsstufe. Eine vollständige Übersicht der Anforderungen finden Sie im Leitfaden zum Adobe Partner Connection Reseller Program.",
      ctr1_gold:
        "Der Fachhändler füllt das vorliegende Online-Anmeldeformular aus und akzeptiert die Bedingungen des Reseller Program.",
      ctr2_gold:
        "Der Fachhändler erfüllt alle Anforderungen für die gewünschte Mitgliedsstufe. Eine vollständige Übersicht der Anforderungen finden Sie im Leitfaden zum Adobe Partner Connection Reseller Program.",

      PP_APC_Header_Label: null,
      OnbrdCriteriaAuthoriseMsg:
        "Bitte best\u00e4tigen Sie, dass Sie zum Ausf\u00fcllen dieser Anmeldung im Namen Ihrer Organisation/Ihres Unternehmens berechtigt sind.",
      OnbrdTermsPartnerCodeMsg:
        "Bitte lesen Sie die Bedingungen und den Verhaltenskodex f\u00fcr Adobe-Partner sorgf\u00e4ltig durch, und akzeptieren Sie diese.",
      OnbrdContactPrefLang: "Bevorzugte Sprache *",
      PP_Adobe_Portal: null,
      ONBLangPref: "Region und Sprache",
      OnbrdCriteriaHeader: "Kriterien f\u00fcr die Anmeldung",
      OnbrdCriteriaHeaderRenewal: "Kriterien f\u00fcr die Erneuerung",
      OnbrdCriteriaHeaderUplevel: "Kriterien f\u00fcr die H\u00f6herstufung",
      ONBCompInfo: "Informationen zur Organisation",
      ONBContsInfo: "Kontaktinformationen",
      SplznQuestionnaireHeader: "Fragebogen",
      ONBPgmAgreement: "Programmvereinbarung",
      ONBPreferredLanguage:
        "Bitte w\u00e4hlen Sie den Standort Ihrer Organisation sowie Ihre bevorzugte Sprache.",
      OnbrdProfileRegion: "Region",
      OnbrdGenSelectErrorMsg: "Bitte w\u00e4hlen Sie einen Wert.",
      OnbrdProfileCountry: "Land",
      OnbrdGenNone: "--Keines--",
      ONBRegCriteriaAgree:
        "Bitte lesen und akzeptieren Sie die Anmeldevoraussetzungen.",
      OnbrdCriteriaBody:
        "Vielen Dank f\u00fcr Ihr Interesse am Adobe Partner Connection Reseller Program.",
      OnbrdCriteriaBodyRenewal:
        "Vielen Dank f\u00fcr Ihr Interesse an der Erneuerung Ihrer Teilnahme am Adobe Partner Connection Reseller Program.",
      OnbrdCriteriaBodyUplevel:
        "Vielen Dank f\u00fcr Ihr Interesse an einer H\u00f6herstufung Ihrer Teilnahme am Adobe Partner Connection Reseller Program.",
      OnbrdCriteriaBody1:
        "Um am Programm teilzunehmen, m\u00fcssen Sie sich zun\u00e4chst online anmelden. Bitte lesen Sie die im Folgenden beschriebenen Anforderungen f\u00fcr die gew\u00fcnschte Mitgliedsstufe und die Anmeldekriterien sorgf\u00e4ltig durch. Best\u00e4tigen Sie anschlie\u00dfend, dass Sie authorisiert sind, das Anmeldeformular im Namen Ihres Unternehmens auszuf\u00fcllen. Klicken Sie auf \u201eWeiter\u201c, um mit der Anmeldung fortzufahren.",
      OnbrdCriteriaSectionHeader: "Kriterien f\u00fcr die Anmeldung",
      OnbrdCriteriaSectionHeaderRenewal: "Kriterien f\u00fcr die Erneuerung",
      OnbrdCriteriaSectionHeaderUplevel:
        "Kriterien f\u00fcr die H\u00f6herstufung",
      OnbrdCriteriaAuthorized:
        "leitender Angestellter oder Mitglied der Gesch\u00e4ftsf\u00fchrung bzw.",
      OnbrdCriteriaAuthorized2:
        "von einem leitenden Angestellten oder Mitglied der Gesch\u00e4ftsf\u00fchrung autorisiert worden, das Anmeldeformular im Namen des Unternehmens auszuf\u00fcllen.",
      ONBEnterCompDetails:
        "Bitte geben Sie folgende Informationen zu Ihrer Organisation an.",
      OnbrdProfileMembershipId: "Mitgliedskennung",
      OnbrdProfileParentMembershipId: "Mitgliedsnummer des Hauptunternehmens",
      OnbrdProfileContractStart: "Vertragsbeginn",
      OnbrdProfilePartnerLevel: "Partnerstufe",
      OnbrdProfileContractEnd: "Vertragsende",
      OnbrdProfileSplzn:
        "Informationen zum Ansprechpartner f\u00fcr Spezialgebiet",
      OnbrdProfileAcctMgr: "Account-Manager",
      OnbrdProfileAddLicenses: "Anzahl weiterer Lizenzen",
      OnbrdProfileFullCompName: "Vollst\u00e4ndiger Name des Unternehmens",
      OnbrdGenInputErrorMsg: "Geben Sie einen Wert ein.",
      OnbrdProfileTradingName: "Handelsname",
      OnbrdProfileBRN: "Handelsregisternummer",
      OnbrdProfilePreferredDistributor: "Bevorzugter Distributor",
      OnbrdProfileYrIncorp: "Gr\u00fcndungsjahr *",
      OnbrdGenInvalidYrFormat: "Bitte folgen Sie Format: YYYY",
      OnbrdGenInvalidYr: "Jahr nicht g\u00fcltig.",
      OnbrdGenInvalidFutureDateMsg:
        "Das Datum liegt in der Zukunft. Bitte geben Sie ein g\u00fcltiges Datum ein.",
      OnbrdProfileCompType:
        "Art des Unternehmens (Alle Zutreffenden auswählen) *",
      OnbrdGenSelectErrorMsg: "Bitte w\u00e4hlen Sie einen Wert.",
      OnbrdProfileCountry: "Land",
      OnbrdGenNone: "--Keines--",
      OnbrdProfileStreet: "Stra\u00dfe und Hausnummer *",
      OnbrdProfileCity: "Ort *",
      OnbrdProfileState: "Bundesland *",
      OnbrdProfilePostCode: "PLZ *",
      OnbrdProfilePrimPhone: "Telefon *",
      OnbrdProfilePrimFax: "Fax",
      OnbrdProfileContactEmail: "E-Mail *",
      OnbrdGenEmailFormatErrMsg: "Ung\u00fcltiges E-Mail-Format.",
      OnbrdProfileCompanyDomainMsg:
        "Die angegebene E-Mail-Dom\u00e4ne des Unternehmens stimmt nicht mit der E-Mail-Dom\u00e4ne des Hauptansprechpartners \u00fcberein.",
      OnbrdProfileEmailDomain: "E-Mail-Dom\u00e4ne",
      OnbrdProfilePrimURL: "Website *",
      OnbrdProfileSecondaryURL: "Alternative URL",
      OnbrdProfileListPartnerFinder: "Eintrag im Reseller Finder?",
      ONBContactDetails:
        "Bitte geben Sie folgende Kontaktinformationen f\u00fcr Ihre Organisation an.",
      OnbrdContactSecContactInfo: "Kontaktinformationen",
      OnbrdContactSectionHeader:
        "HINWEIS: Sie m\u00fcssen einen Hauptansprechpartner und einen zweiten Ansprechpartner angeben. Auf Wunsch k\u00f6nnen Sie Ansprechpartner f\u00fcr technische, vertriebs- und Marketing-relevante Anliegen hinzuf\u00fcgen.",
      ONBAddSecBtn: "Alternativen Ansprechpartner hinzuf\u00fcgen",
      ONBAddOtherBtn: "Anderen Ansprechpartner hinzuf\u00fcgen",
      ReAssignContactNameLabel: "Name des Ansprechpartners",
      ConsolePartnerContactEmail: "E-Mail",
      ConsolePartnerContactCType: "Haupt-Ansprechpartnerart",
      TrngManage: "Verwalten",
      OnbrdContactPrimaryType: "Hauptansprechpartner",
      OnbrdContactSecondaryType: "Zweiter Ansprechpartner",
      OnbrdContactOtherType: "Andere",
      ConsolePartnerBtnEdit: "Bearbeiten",
      QBPDelete: "L\u00f6schen",
      OnbrdContactPriConHeader: "Hauptansprechpartner",
      OnbrdContactSecConHeader: "Zweiter Ansprechpartner",
      OnbrdContactOther: "Weitere Ansprechpartner",
      OnbrdContactPrefix: "Titel",
      OnbrdContactTitle: "Namenszusatz",
      prefixMaxLengthError:
        "Prefix must be 10 characters or fewer, Kindly update.",
      suffixMaxLengthError:
        "Suffix must be 10 characters or fewer, Kindly update.",
      OnbrdContactFName: "Vorname *",
      OnbrdContactLName: "Nachname *",
      OnbrdContactPhone: "Telefon *",
      OnbrdContactJRole: "Position *",
      OnbrdContactEmail: "E-Mail *",
      OnbrdContactAddtlType: "Funktion",
      OnbrdContactDeactivate: "Deaktivieren",
      OnbrdContactDeactivateHelp:
        "Wenn Sie \u201eDeaktivieren\u201c ausw\u00e4hlen, wird der Ansprechpartner gel\u00f6scht und hat keinen Zugang mehr zu den Systemen von Adobe.",
      TrngSaveClose: "Speichern und schlie\u00dfen",
      TrngClose: "Schlie\u00dfen",
      ONBRegCerContacts:
        "Please select and complete the required COC training course before submitting your request.",
      OnbrdCertContactSectionHeader:
        "F\u00fcr die gew\u00fcnschte Stufe ist eine Vertriebsschulung erforderlich. Mindestens eine Person muss die Trainings-Einheit \u201eVerhaltenskodex f\u00fcr Gesch\u00e4ftspartner\u201c erfolgreich abschlie\u00dfen. Eine vollst\u00e4ndige Liste der Trainings-Anforderungen finden Sie im Leitfaden zum Adobe Partner Connection Reseller/Retail-Programm. Geben Sie unten die Personen an, die das Training abgeschlossen haben.",
      OnbrdContactAdd: "Weiteren Ansprechpartner hinzuf\u00fcgen",
      OnbrdCertContactFName: "Vorname",
      OnbrdCertContactLName: "Nachname",
      OnbrdCertContactEmail: "E-Mail",
      OnbrdCertContactCertification: "TRAINING ABGESCHLOSSEN",
      TrngManage: "Verwalten",
      ConsolePartnerBtnEdit: "Bearbeiten",
      ONBCerContactDetails:
        "Kontaktinformationen eines zertifizierten Ansprechpartners",
      OnbrdCertContactDeactivated: "DEAKTIVIEREN",
      ONBRetailSplQues: "Einzelhandelsprogramm Spezialisierungsfragebogen",
      OnbrdPrimaryQuestionnaireHeader:
        "Registrierungsfragebogen zur Gesetzeskonformit\u00e4t",
      OnbrdSecondaryQuestionnaireHeader: "Anmeldung \u2013 Zweiter Fragebogen",
      OnbrdPartnerFinderInfoHeader:
        "Registrierungsfragebogen zu gesch\u00e4ftlichen Aktivit\u00e4ten",
      ONBAgreeToSubmit:
        "Bitte lesen und akzeptieren Sie die Programmvereinbarung.",
      OnbrdTermsSectionHeader2:
        "Bitte lesen sie die Allgemeinen Gesch\u00e4ftsbedingungen. Um diese zu akzeptieren muessen Sie nach unten scrollen und an der gekennzeichneten Stelle einen Haken setzen.",
      OnbrdTermsSectionHeader: "Bedingungen",
      OnbrdTermsAccept:
        "ICH HABE DIE IM VORLIEGENDEN VERTRAGSTEXT AUFGEF\u00dcHRTEN BESTIMMUNGEN GELESEN, ERKL\u00c4RE MICH MIT IHNEN EINVERSTANDEN UND BEST\u00c4TIGE HIERMIT, DASS ICH AUTORISIERT BIN, DEN FACHH\u00c4NDLER AN DIESEN VERTRAG ZU BINDEN.",
      OnbrdThankYouNewRegistered:
        "Vielen Dank f\u00fcr Ihre Anmeldung beim Adobe Partner Connection Reseller-Programm. Sie erhalten in K\u00fcrze eine Eingangsbest\u00e4tigung per E-Mail. Wir informieren Sie weiterhin regelm\u00e4\u00dfig \u00fcber den Bearbeitungsstatus Ihres Antrags.",
      OnbrdThankYouRenewalRegistered:
        "Ihre Erneuerung wurde angemeldet, und Sie erhalten in K\u00fcrze eine Best\u00e4tigung. Wir halten Sie per E-Mail \u00fcber weitere Aktualisierungen der Erneuerung auf dem Laufenden.",
      OnbrdThankYouRenewalCertGold:
        "Ihre Erneuerung wurde angemeldet, und Sie erhalten in K\u00fcrze eine Best\u00e4tigung. Wir halten Sie per E-Mail \u00fcber weitere Aktualisierungen der Anmeldung auf dem Laufenden.",
      OnbrdThankYouUplevelCertGold:
        "Vielen Dank f\u00fcr Ihren Antrag auf H\u00f6herstufung Ihrer Teilnahme am Adobe Partner Connection Reseller-Programm. Sie erhalten in K\u00fcrze eine Eingangsbest\u00e4tigung per E-Mail. Wir informieren Sie weiterhin regelm\u00e4\u00dfig \u00fcber den Bearbeitungsstatus Ihres Antrags.",
      OnbrdThankYouClick: "Klicken Sie",
      OnbrdThankYouEducURL: null,
      OnbrdThankYouHere: "hier,",
      OnbrdThankYouEd:
        "um Ihre Spezialisierung auf den Bereich Education zu erneuern.",
      OnbrdThankYouLegalURL: null,
      OnbrdThankYouLeg:
        "um Ihre Spezialisierung auf den Bereich SAM-Dienste zu erneuern.",
      OnbrdThankYouProVedioURL: null,
      OnbrdThankYouPv:
        "um Ihre Spezialisierung auf den Bereich ProVideo zu erneuern.",
      OnbrdThankYouGovURL: null,
      OnbrdThankYouGv: null,
      OnbrdThankYouDpsURL:
        "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=DigitalPublishingSuite&id=",
      OnbrdThankYouDps: null,
      OnbrdThankYouHelpDesk:
        "Falls Sie Fragen zum Reseller-Programm oder zum Anmeldeprozess haben, wenden Sie sich bitte an den Adobe-Partner Connection Helpdesk.",
      OnbrdErrorUnauthorized:
        "Sie sind nicht berechtigt, diese Seite aufzurufen. Wenn Sie bei der Registrierung bzw. H\u00f6herstufung Hilfe ben\u00f6tigen, wenden Sie sich bitte an den Kundendienst f\u00fcr Adobe-Partner.",
      OnbrdErrorNewRegEmailExist:
        "<br/><br/> \n<p>Ihre Anmeldung konnte nicht bearbeitet werden, da Ihre E-Mail-Adresse bereits im System vorhanden ist.</p> \n<br/><br/><br/><br/><br/>",
      OnbrdErrorNewRegEmailFree:
        "<br/><br/> \n<p>Kostenlose E-Mail-Adressen und ISP-Adressen sind f\u00fcr Unternehmen und Hauptansprechpartner nicht zul\u00e4ssig. Um eine Adobe-ID zu beantragen, geben Sie bitte eine gesch\u00e4ftliche E-Mail-Adresse an.</p> \n<br/><br/><br/><br/><br/>",
      OnbrdErrorExpiredLink:
        "<br/><br/>\n<p>Ihr Link ist abgelaufen. Bitte wenden Sie sich an den Kundendienst f\u00fcr Adobe-Partner.</p>\n<br/><br/><br/><br/><br/>",
      OnbrdInterimUplevelExistsMsg:
        "Vielen Dank f\u00fcr Ihr Interesse an einer H\u00f6herstufung Ihrer Teilnahme am Adobe Partner Connection Reseller Program. Ein bereits vorliegender entsprechender Antrag wird derzeit gepr\u00fcft. Zum gegebenen Zeitpunkt informiert Adobe Sie per E-Mail \u00fcber den aktuellen Stand Ihres Antrags.",
      OnbrdProgNextStepExistMsg:
        "Dieser Fachh\u00e4ndler ist bereits f\u00fcr das Adobe Partner Connection Reseller-Programm angemeldet. Klicken Sie auf die Schaltfl\u00e4che \u201eE-Mail senden\u201c, um den Fachh\u00e4ndler \u00fcber Ihr Interesse am Programm zu informieren.",
      OnbrdGenPreviousLabel: "Zur\u00fcck",
      OnbrdGenSaveExitLabel: "Speichern und beenden",
      OnbrdGenSubmitLabel: "Abschicken",
      OnbrdGenNextLabel: "Weiter",
      OnbrdPartnerFinderProdExpOther:
        "Product Expertise – Other [Maximal 255 Zeichen]",
      OnbrdPrimaryQuestionnaireSectionHeader:
        "Bitte beantworten Sie die folgenden Fragen zu Ihrem Unternehmen.",
      renewal_unauthorized:
        "Sie sind nicht berechtigt, diese Seite aufzurufen.",

      OnbrdPartnerFinderInfoBusProfSection: "Unternehmensprofil",
      OnbrdPartnerFinderSSCountriesAmerica:
        "Internationaler Vertrieb und Support (Nord-/Südamerika)",
      OnbrdPartnerFinderSSCountriesEurope:
        "Internationaler Vertrieb und Support (Europa/Zentralasien)",
      OnbrdPartnerFinderSSCountriesAfrica:
        "Internationaler Vertrieb und Support (Afrika/Naher Osten)",
      OnbrdPartnerFinderSSCountiresAsia:
        "Internationaler Vertrieb und Support (Asien/Pazifik)",
      OnbrdPartnerFinderBusinessDescEng:
        "Geschäftsbeschreibung (Englisch) [Maximal 255 Zeichen]",
      OnbrdLengthValidationErrorMsg: "Bitte geben Sie maximal 255 Zeichen ein.",
      OnbrdPartnerFinderAltLang: "Andere Sprache",
      OnbrdPartnerFinderBusinessDescOther:
        "Geschäftsbeschreibung – Andere Sprache [Maximal 255 Zeichen]",
      OnbrdPartnerFinderOrgSizeSection: "Größe des Unternehmens",
      OnbrdPartnerFinderTotalEmp: "Gesamtanzahl Mitarbeiter",
      OnbrdPartnerFinderTotInsideTelSFDC:
        "Gesamtanzahl Mitarbeiter im internen/telefonischen Vertrieb",
      OnbrdPartnerFinderTotOutsideDirSFDC:
        "Gesamtanzahl Mitarbeiter im externen/Direktvertrieb",
      OnbrdPartnerFinderTotTechProfOnStaff:
        "Gesamtanzahl Mitarbeiter im IT-Bereich",
      OnbrdPartnerFinderTotDevOnStaff:
        "Gesamtanzahl Mitarbeiter in der Entwicklung",
      OnbrdPartnerFinderTotMarkProfOnStaff:
        "Gesamtanzahl Mitarbeiter im Marketing",
      OnbrdPartnerFinderCustSegmentSection: "Kundensegment",
      OnbrdPartnerFinderPrimFocus: "Primärer Geschäftsfokus",
      OnbrdGenErrorLabel: "Fehler:",
      AcctCustomerSegmentErrorMsg:
        "Die Auswahl muss innerhalb der Gruppe „Kundensegment“ eindeutig sein.",
      OnbrdPartnerFinderSecFocus: "Sekundärer Geschäftsfokus",
      OnbrdPartnerFinderNotSig: "Nicht Nennenswert",
      OnbrdPartnerFinderProdExpSection: "Produktspezifisches Know-how",
      OnbrdPartnerFinderProdExpAdobe: "Produktspezifisches Know-how – Adobe",
      OnbrdPartnerFinderProdExpOther:
        "Product Expertise – Other [Maximal 255 Zeichen]",
      OnbrdPartnerFinderProductSoldSection: "Produkte im aktuellen Portfolio",
      OnbrdPartnerFinderProdSoldAdobe: "Verkaufte Produkte – Adobe",
      OnbrdPartnerFinderProdExpSoldOther:
        "Products Sold – Other [Maximal 255 Zeichen]",
      OnbrdPartnerFinderSrvcOfferedSection: "Angebotene Dienstleistungen",
      AcctServicesOfferedErrorMsg:
        "Die Auswahl muss innerhalb der Gruppe „Angebotene Dienstleistungen“ eindeutig sein.",
      OnbrdPartnerFinderVerticalFocusSection: "Vertikaler Fokus",
      OnbrdPartnerFinderVertGovError:
        "Sie können ‘Behörden’ nicht auswählen, da Sie bei der Compliance Frage, ob Sie schon mal an eine ‘Behörde’ verkauft haben, mit Nein beantwortet haben.",
      OnbrdPartnerFinderVertEducError:
        "Sie können ‘Education’ nicht auswählen, da Sie bei der Compliance Frage, ob Sie schon mal an einen ‘Education’ Kunden verkauft haben, mit Nein beantwortet haben.",
      AcctVerticalSegmentErrorMsg:
        "Die Auswahl muss innerhalb der Gruppe „Vertikaler Fokus“ eindeutig sein.",
      Previous: "Zur\u00fcck",
      "Save and Exit": "Speichern und beenden",
      Submit: "Abschicken",
      Next: "Weiter",

      select_level: "Stufe auswählen",
      basic_comp_info: "Allgemeine Informationen zur Organisation",
      location: "Standort",
      comp_email_address: "E-Mail-Adresse der Organisation *",
      save_n_exit_body:
        "Sie können den Anmeldevorgang jederzeit wiederaufnehmen – genau dort, wo Sie aufgehört haben. Sie können dieses Browser-Fenster jetzt schließen oder zu einer anderen Website wechseln.",
      contact_type: "Art Ansprechpartner (Alle Zutreffenden auswählen) *",
      confirm_deletion: "Löschen bestätigen",
      delete_confirm_msg: "Möchten Sie ",
      delete_confirm_msg1: "als Ansprechpartner wirklich löschen ?",
      prog_agmt_text:
        "Sie haben es fast geschafft. Lesen Sie zum Abschluss bitte die Partner Connection Program-Vereinbarung für Fachhändler durch. Geben Sie an der entsprechenden Stelle an, dass Sie mit den Bestimmungen einverstanden sind. ",
      add: "Hinzufügen",
      Select: "Auswählen",
      select_all_that_apply: "Alle Zutreffenden auswählen",
      i_certify: "Hiermit bestätige ich, dass ich Folgendes bin:",
      msg_saving_data: "Ihre Formulardaten werden gespeichert",
      msg_data_saved: "Ihre Daten wurden gespeichert.",
      add_certified_contacts: "Zertifizierte Ansprechpartner hinzufügen",
      add_certified_msg:
        "Fügen Sie im Folgenden Details zum zertifizierten Ansprechpartner hinzu. Klicken Sie anschließend auf „Speichern“.",
      course_completed: "Abgeschlossene Trainings (Kurse) ",
      course_completed_COC: "Verhaltenskodex für Partner - Status",
      errorForNoCOC_1:
        "Mindestens eine Person muss die Schulung zum Verhaltenskodex für Partner absolvieren, um mit dem Antrag fortfahren zu können. Um die Schulung zu absolvieren, öffnen Sie bitte das ",
      errorForNoCOC_2: "Adobe Channel Training Centre",
      errorForNoCOC_3:
        " über den Link unterhalb der Tabelle. Sobald Sie die Schulung abgeschlossen haben, klicken Sie bitte auf die Schaltfläche REFRESH, um den Kursabschlussstatus der Kontakte zu aktualisieren.",
      logInCPButton: "Bei Captivate Prime anmelden:",
      refresh: "Aktualisieren",
      course_completed_ff:
        "Abgeschlossene Trainings (Kurse)(Alle Zutreffenden auswählen)",
      Register: "Jetzt registrieren",
      "Contact Helpdesk": "Helpdesk kontaktieren",

      prog_agmt_checkbox:
        "ICH HABE DIE IM VORLIEGENDEN VERTRAGSTEXT AUFGEFÜHRTEN BESTIMMUNGEN GELESEN, ERKLÄRE MICH MIT IHNEN EINVERSTANDEN UND BESTÄTIGE HIERMIT, DASS ICH AUTORISIERT BIN, DEN FACHHÄNDLER AN DIESEN VERTRAG ZU BINDEN.",
      ConsolePartnerAccountListPartnerFinder: "Eintrag im Reseller Finder (?)",
      ConsolePartnerContactHeader: "Ansprechpartner",

      thank_you: "Vielen Dank!",
      ConsolePartnerConActive: "Gültig",
      Return_to_Adobe_Channel_Partners: "Adobe Partner Connection",
      "Continue Enrollment": "Einschreibung",
      problem_header: "Ein Problem ist aufgetreten.",
      sign_in: "Mit Adobe ID anmelden",
      associated_other_account:
        "Die Adobe ID, mit der du dich angemeldet hast (%{email}), wird bereits für ein anderes Partnerprogramm von Adobe verwendet: %{program}. Melde dich mit einer anderen Adobe ID an, oder kontaktiere den Helpdesk, um mit deiner Registrierung fortzufahren.",
      OnbrdGenInvalidTokenErrMsg:
        "Ihr Link ist bereits abgelaufen. Bitte wenden Sie sich an den Kundendienst.",
    },
  },
  it_IT: {
    uplevelRenewal: {
      PP_Adobe_Portal: null,
      PP_APC_Header_Label: null,
      ONBUplevelInfo: "Seleziona il livello desiderato.",
      ONBNewLevel: "Nuovo livello",
      OnbrdInterimUplevelHeader:
        "Selezionare il livello per cui si desidera effettuare l'iscrizione.",
      OnbrdGenCertifiedLevel: null,
      OnbrdGenGoldLevel: null,
      OnbrdGenErrorLabel: "Errore:",
      OnbrdGenInputErrorMsg: "Immettere un valore.",
      NAUplevelProgramType: null,
      NAUplevelRetailSpecialization: null,
      OnbrdInterimSelectButton: "Seleziona",

      ctr1_certified:
        "Il rivenditore è tenuto a compilare questa iscrizione online e ad accettare i Termini e le Condizioni del Reseller Program.",
      ctr2_certified:
        "Il rivenditore deve soddisfare tutti i criteri del livello desiderato. Per l'elenco completo dei requisiti, consultare la Guida dell’Adobe Partner Connection Reseller Program.",
      ctr1_gold:
        "Il rivenditore è tenuto a compilare questa iscrizione online e ad accettare i Termini e le Condizioni del Reseller Program.",
      ctr2_gold:
        "Il rivenditore deve soddisfare tutti i criteri del livello desiderato. Per l'elenco completo dei requisiti, consultare la Guida dell’Adobe Partner Connection Reseller Program.",

      PP_APC_Header_Label: null,
      OnbrdCriteriaAuthoriseMsg:
        "Selezionare la casella indicata per confermare l’autorizzazione al completamento di questa iscrizione per conto dell’organizzazione.",
      OnbrdTermsPartnerCodeMsg:
        "Verificare i termini e le condizioni del codice di condotta di Adobe Business Partner e selezionare le caselle indicate per confermare l'adesione.",
      OnbrdContactPrefLang: "Lingua preferita *",
      PP_Adobe_Portal: null,
      ONBLangPref: "Area geografica e lingua",
      OnbrdCriteriaHeader: "Criteri di registrazione",
      OnbrdCriteriaHeaderRenewal: "Criteri di rinnovo",
      OnbrdCriteriaHeaderUplevel: "Criteri per passaggio a livello superiore",
      ONBCompInfo: "Informazioni sull'azienda",
      ONBContsInfo: "Informazioni di contatto",
      SplznQuestionnaireHeader: "Questionario",
      ONBPgmAgreement: "Contratto del programma",
      ONBPreferredLanguage:
        "Seleziona l'area di appartenenza della tua organizzazione e la lingua preferita.",
      OnbrdProfileRegion: "Area geografica",
      OnbrdGenSelectErrorMsg: "Selezionare un valore.",
      OnbrdProfileCountry: "Paese",
      OnbrdGenNone: "--Nessuna--",
      ONBRegCriteriaAgree:
        "Leggi attentamente i criteri di registrazione e indica che li accetti.",
      OnbrdCriteriaBody:
        "La ringraziamo per l’interesse verso l’ Adobe Partner Connection Reseller Program.",
      OnbrdCriteriaBodyRenewal:
        "Grazie per la richiesta di rinnovo dell'abbonamento all’Adobe Partner Connection Reseller Program.",
      OnbrdCriteriaBodyUplevel:
        "La ringraziamo per l’aggiornamento  all’Adobe Partner Connection Reseller Program.",
      OnbrdCriteriaBody1:
        "La procedura di adesione inizia con la seguente iscrizione online. La preghiamo di consultare i requisiti del Reseller Program per il livello desiderato e i criteri di registrazione riportati di seguito. Quando è pronto a procedere, la preghiamo di confermare l'autorizzazione a compilare la presente domanda. Fare clic su Avanti per procedere.",
      OnbrdCriteriaSectionHeader: "Criteri di registrazione",
      OnbrdCriteriaSectionHeaderRenewal: "CRITERI DI RINNOVO",
      OnbrdCriteriaSectionHeaderUplevel:
        "CRITERI PER PASSAGGIO A LIVELLO SUPERIORE",
      OnbrdCriteriaAuthorized: "responsabile dell'azienda",
      OnbrdCriteriaAuthorized2:
        "persona espressamente autorizzata da un funzionario o dal responsabile a compilare questa domanda per conto dell'azienda.",
      ONBEnterCompDetails:
        "Fornisci le informazioni seguenti sulla tua organizzazione.",
      OnbrdProfileMembershipId: "ID di iscrizione",
      OnbrdProfileParentMembershipId: "ID di iscrizione principale",
      OnbrdProfileContractStart: "Data di inizio contratto",
      OnbrdProfilePartnerLevel: "Livello partner",
      OnbrdProfileContractEnd: "Data di fine contratto",
      OnbrdProfileSplzn: "Informazioni sullo specialista",
      OnbrdProfileAcctMgr: "Responsabile clienti",
      OnbrdProfileAddLicenses: "# di licenze supplementari",
      OnbrdProfileFullCompName: "Nome completo dell’azienda",
      OnbrdGenInputErrorMsg: "Immettere un valore.",
      OnbrdProfileTradingName: "Nome commerciale",
      OnbrdProfileBRN: "Partita IVA",
      OnbrdProfilePreferredDistributor: "Distributore Preferito",
      OnbrdProfileYrIncorp: "Anno di costituzione *",
      OnbrdGenInvalidYrFormat: "Si prega di seguire il formato: YYYY",
      OnbrdGenInvalidYr: "Anno non è valido.",
      OnbrdGenInvalidFutureDateMsg: null,
      OnbrdProfileCompType:
        "Tipo azienda (Seleziona tutte le risposte applicabili) *",
      OnbrdProfileStreet: "Via *",
      OnbrdProfileCity: "Località *",
      OnbrdProfileState: "Provincia *",
      OnbrdProfilePostCode: "CAP *",
      OnbrdProfilePrimPhone: "Num. Telefono Principale *",
      OnbrdProfilePrimFax: "Num. Fax Principale",
      OnbrdProfileContactEmail: "E-mail *",
      OnbrdGenEmailFormatErrMsg: "Formato e-mail non valido.",
      OnbrdProfileCompanyDomainMsg:
        "Il dominio e-mail aziendale immesso non corrisponde al dominio e-mail del contatto primario.",
      OnbrdProfileEmailDomain: "Dominio dell’e-mail",
      OnbrdProfilePrimURL: "Sito web *",
      OnbrdProfileSecondaryURL: "Sito web secondario",
      OnbrdProfileListPartnerFinder:
        "Desiderate essere inclusi nell'elenco Reseller Finder?",
      ONBContactDetails:
        "Fornisci le informazioni di contatto della tua organizzazione.",
      OnbrdContactSecContactInfo: "Informazioni del contatto",
      OnbrdContactSectionHeader:
        "NOTA: É obbligatorio specificare i contatti principale e secondario. È possibile aggiungere altri contatti che verranno utilizzati per l'invio di aggiornamenti relativi a vendite, marketing e questioni tecniche.",
      ONBAddSecBtn: "Aggiungi secondario",
      ONBAddOtherBtn: "Aggiungi altro",
      ReAssignContactNameLabel: "Nome contatto",
      ConsolePartnerContactEmail: "E-mail",
      ConsolePartnerContactCType: "Tipo di contatto principale",
      TrngManage: "Gestisci",
      OnbrdContactPrimaryType: "Principale",
      OnbrdContactSecondaryType: "Secondario",
      OnbrdContactOtherType: "Altro",
      ConsolePartnerBtnEdit: "Modifica",
      QBPDelete: "Elimina",
      OnbrdContactPriConHeader: "Contatto Principale",
      OnbrdContactSecConHeader: "Contatto Secondario",
      OnbrdContactOther: "Altri contatti",
      OnbrdContactPrefix: "Appellativo",
      OnbrdContactTitle: "Titolo",
      prefixMaxLengthError:
        "Prefix must be 10 characters or fewer, Kindly update.",
      suffixMaxLengthError:
        "Suffix must be 10 characters or fewer, Kindly update.",
      OnbrdContactFName: "Nome *",
      OnbrdContactLName: "Cognome *",
      OnbrdContactPhone: "Telefono *",
      OnbrdContactJRole: "Mansione *",
      OnbrdContactEmail: "E-mail *",
      OnbrdContactAddtlType: "Tipo",
      OnbrdContactDeactivate: "Disattiva",
      OnbrdContactDeactivateHelp:
        "Se viene selezionata la casella di disattivazione, il contatto viene rimosso dall'account e non avrà più accesso ai sistemi Adobe.",
      TrngSaveClose: "Salva e chiudi",
      TrngClose: "Chiudi",
      ONBRegCerContacts:
        "Please select and complete the required COC training course before submitting your request.",
      OnbrdCertContactSectionHeader:
        "Per il livello desiderato è richiesta un'adeguata formazione alla vendita. Almeno una persona deve completare il corso \"Codice di condotta dei partner\". Per l'elenco completo dei requisiti di formazione, consultare la Guida del programma per rivenditori o retailer Adobe Partner Connection. Nei campi seguenti è possibile individuare i contatti che hanno completato la formazione necessaria.",
      OnbrdContactAdd: "Aggiungi un altro contatto",
      OnbrdCertContactFName: "Nome",
      OnbrdCertContactLName: "Cognome",
      OnbrdCertContactEmail: "E-mail",
      OnbrdCertContactCertification: "CORSO DI FORMAZIONE COMPLETATO",
      TrngManage: "Gestisci",
      ONBCerContactDetails: "Dettagli contatto certificato",
      OnbrdCertContactDeactivated: "DISATTIVA",
      ONBRetailSplQues:
        "Vendita al dettaglio Specializzazione Questionario Programma",
      OnbrdPrimaryQuestionnaireHeader:
        "Questionario di conformità registrazione",
      OnbrdSecondaryQuestionnaireHeader: "Questionario registrazione 2",
      OnbrdPartnerFinderInfoHeader: "Questionario aziendale di registrazione",
      ONBAgreeToSubmit:
        "Leggi attentamente il contratto del programma e indica che ne accetti il contenuto.",
      OnbrdTermsSectionHeader2:
        "Verificare I Termini e le Condizioni del Reseller Program, scorrendo fino alla fine della pagina per confermare l'accettazione ove indicato.",
      OnbrdTermsSectionHeader: "Termini e condizioni",
      OnbrdTermsAccept:
        "HO LETTO, COMPRESO E ACCETTATO DI RISPETTARE I TERMINI E LE CONDIZIONI QUI INDICATI E DICHIARO E GARANTISCO DI ESSERE AUTORIZZATO A VINCOLARE IL RIVENDITORE.",
      OnbrdThankYouNewRegistered:
        "La ringraziamo per l interesse verso l’ Adobe Partner Connection Reseller Program. Abbiamo ricevuto la sua richiesta. A breve riceverà un'e-mail di conferma. La contatteremo per aggiornarla relativamente alla domanda presentata.",
      OnbrdThankYouRenewalRegistered:
        "Il rinnovo è stato archiviato. Riceverete presto un e-mail di conferma. Vi contatteremo via e-mail per qualsiasi aggiornamento relativo al rinnovo.",
      OnbrdThankYouRenewalCertGold:
        "Il rinnovo è stato archiviato. Riceverete presto un e-mail di conferma. Vi contatteremo via e-mail per qualsiasi aggiornamento relativo al rinnovo.",
      OnbrdThankYouUplevelCertGold:
        "Grazie per la richiesta di passaggio al nuovo livello dell’Adobe Partner Connection Reseller Program. Abbiamo ricevuto la vostra richiesta. A breve riceverete un'e-mail di conferma. Vi contatteremo via e-mail per qualsiasi aggiornamento relativo alla domanda presentata.",
      OnbrdThankYouClick: "Fare clic",
      OnbrdThankYouEducURL:
        "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=Education&id=",
      OnbrdThankYouHere: "qui",
      OnbrdThankYouEd: "per rinnovare la specializzazione Education.",
      OnbrdThankYouLegalURL:
        "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=SAM+services&id=",
      OnbrdThankYouLeg: "per rinnovare la specializzazione Servizi SAM.",
      OnbrdThankYouProVedioURL:
        "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=ProVideo&id=",
      OnbrdThankYouPv: "per rinnovare la specializzazione ProVideo.",
      OnbrdThankYouGovURL:
        "http://adobedealreg.sfqa.cs12.force.com/Onboarding/SplznWizardPage?sp=Government&id=",
      OnbrdThankYouGv: null,
      OnbrdThankYouDpsURL:
        "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=DigitalPublishingSuite&id=",
      OnbrdThankYouDps: null,
      OnbrdThankYouHelpDesk:
        "Per eventuali domande sull’Adobe Partner Connection Reseller Program o sulla domanda presentata, contattare l’Adobe Partner Connection Help Desk",
      OnbrdErrorUnauthorized:
        "Non si dispone delle autorizzazioni per visualizzare questa pagina. Rivolgersi all'help desk per i partner per ricevere assistenza relativa a registrazione/passaggio a un livello superiore.",
      OnbrdErrorNewRegEmailExist:
        "<br/><br/>\n<p>Impossibile elaborare la registrazione perché l'indirizzo e-mail è già presente nel sistema.</p>\n<br/><br/><br/><br/><br/>",
      OnbrdErrorNewRegEmailFree:
        "<br/><br/> \n<p>Domini e-mail e ISP liberi non consentiti come domini e-mail primari e aziendali. Registrarsi per ottenere un ID Adobe con un account e-mail aziendale.</p> \n<br/><br/><br/><br/><br/>",
      OnbrdErrorExpiredLink:
        "<br/><br/>\n<p>Il collegamento è già scaduto. Rivolgersi all’Adobe Partner Connection Help Desk.</p>\n<br/><br/><br/><br/><br/>",
      OnbrdInterimUplevelExistsMsg:
        "Grazie per aver chiesto di passare a un nuovo livello del programma Adobe Partner Connection. Stiamo già esaminando una precedente domanda di promozione al nuovo livello. Ti contatteremo via e-mail per qualsiasi aggiornamento relativo alla domanda presentata.",
      OnbrdProgNextStepExistMsg:
        "Questo rivenditore è già registrato al programma Rivenditori Adobe Partner Connection. È possibile notificare al rivenditore il proprio interesse a partecipare a questo programma facendo clic sul seguente pulsante Invia e-mail.",
      OnbrdGenPreviousLabel: "Indietro",
      OnbrdGenSaveExitLabel: "Salva ed esci",
      OnbrdGenSubmitLabel: "Invia",
      OnbrdGenNextLabel: "Avanti",
      OnbrdPartnerFinderProdExpOther:
        "Conoscenza Prodotto [Massimo 255 caratteri]",
      OnbrdPrimaryQuestionnaireSectionHeader:
        "Rispondere alle seguenti domande sulla propria organizzazione.",
      renewal_unauthorized:
        "Non si dispone delle autorizzazioni per visualizzare questa pagina.",

      OnbrdPartnerFinderInfoBusProfSection: "Profilo aziendale",
      OnbrdPartnerFinderSSCountriesAmerica:
        "Assistenza e Vedita in altri Paesi (America)",
      OnbrdPartnerFinderSSCountriesEurope:
        "Assistenza e Vedita in altri Paesi (Europa e Asia Centrale)",
      OnbrdPartnerFinderSSCountriesAfrica:
        "Assistenza e Vedita in altri Paesi (Africa e Medio Oriente)",
      OnbrdPartnerFinderSSCountiresAsia:
        "Assistenza e Vedita in altri Paesi (Asia Pacifica)",
      OnbrdPartnerFinderBusinessDescEng:
        "Descrizione aziendale( inglese) [Massimo 255 caratteri]",
      OnbrdLengthValidationErrorMsg: "Immettere un massimo di 255 caratteri.",
      OnbrdPartnerFinderAltLang: "Lingua alternativa",
      OnbrdPartnerFinderBusinessDescOther:
        "Descrizione aziendale( altra lingua) [Massimo 255 caratteri]",
      OnbrdPartnerFinderOrgSizeSection: "Dimensioni organizzazione",
      OnbrdPartnerFinderTotalEmp: "Numero totale di impiegati",
      OnbrdPartnerFinderTotInsideTelSFDC:
        "Totale forza di vendita interna/telefonica",
      OnbrdPartnerFinderTotOutsideDirSFDC:
        "Totale forza di vendita esterna/diretta",
      OnbrdPartnerFinderTotTechProfOnStaff: "Totale esperti tecnici impiegati",
      OnbrdPartnerFinderTotDevOnStaff: "Totale sviluppatori impiegati",
      OnbrdPartnerFinderTotMarkProfOnStaff:
        "Totale esperti marketing impiegati",
      OnbrdPartnerFinderCustSegmentSection: "Segmento cliente",
      OnbrdPartnerFinderPrimFocus: "Focus primario",
      OnbrdGenErrorLabel: "Errore:",
      AcctCustomerSegmentErrorMsg:
        "Il valore selezionato deve essere univoco all’interno del gruppo Segmento cliente.",
      OnbrdPartnerFinderSecFocus: "Focus secondario",
      OnbrdPartnerFinderNotSig: "Non rilevante",
      OnbrdPartnerFinderProdExpSection: "Conoscenza prodotto",
      OnbrdPartnerFinderProdExpAdobe: "Conoscenza prodotto - Adobe",
      OnbrdPartnerFinderProdExpOther:
        "Conoscenza Prodotto [Massimo 255 caratteri]",
      OnbrdPartnerFinderProductSoldSection: "Prodotti attualmente venduti",
      OnbrdPartnerFinderProdSoldAdobe: "Prodotti venduti - Adobe",
      OnbrdPartnerFinderProdExpSoldOther:
        "Prodotti Venduti- Altro [Massimo 255 caratteri]",
      OnbrdPartnerFinderSrvcOfferedSection: "Servizi offerti",
      AcctServicesOfferedErrorMsg:
        "Il valore selezionato deve essere univoco all’interno del gruppo Servizi offerti.",
      OnbrdPartnerFinderVerticalFocusSection: "Focus verticale",
      OnbrdPartnerFinderVertGovError:
        "Non è possibile selezionare Settore Pubblico perchè ha risposto No alle domande di conformità riguardo alla vendita a clienti del Settore Pubblico.",
      OnbrdPartnerFinderVertEducError:
        "Non è possibile selezionare Settore Istruzione perchè ha risposto No alle domande di conformità riguardo alla vendita a clienti del  Settore Istruzione.",
      AcctVerticalSegmentErrorMsg:
        "Il valore selezionato deve essere univoco all’interno del gruppo Segmento verticale.",
      Previous: "Indietro",
      "Save and Exit": "Salva ed esci",
      Submit: "Invia",
      Next: "Avanti",

      select_level: "Seleziona il livello",
      basic_comp_info: "Informazioni di base sull'azienda",
      location: "Sede",
      comp_email_address: "Indirizzo e-mail dell'azienda *",
      save_n_exit_body:
        "Torna in qualsiasi momento per completare il processo di iscrizione. Potrai riprendere la procedura esattamente da dove l’hai interrotta. Ora puoi chiudere questa finestra del browser o navigare su un altro sito web.",
      contact_type:
        "Tipo di contatto (Seleziona tutte le risposte applicabili) *",
      confirm_deletion: "Conferma cancellazione",
      delete_confirm_msg: "Confermi di voler eliminare il contatto: ",
      delete_confirm_msg1: "?",
      prog_agmt_text:
        "Ci siamo quasi. L'ultimo passaggio consiste nel leggere il contratto del programma Rivenditori Adobe Partner Connection. Conferma l'accettazione dove indicato.",
      add: "Aggiungi",
      Select: "Effettua una selezione",
      select_all_that_apply: "Seleziona tutte le risposte applicabili",
      i_certify: "Dichiaro di ricoprire uno di questi due ruoli:",
      msg_saving_data: "Salvataggio dei dati del modulo in corso...",
      msg_data_saved: "I tuoi dati sono stati salvati.",
      add_certified_contacts: "Aggiungi contatti certificati",
      add_certified_msg:
        "Aggiungi qui sotto i dettagli di un contatto certificato. Quindi fai clic su Salva.",
      course_completed: "Corsi di formazione completati ",
      course_completed_COC: "Codice di condotta dei partner - Status",
      errorForNoCOC_1:
        "Almeno una persona deve completare la formazione sul Codice di condotta per i partner per poter procedere con la richiesta. Per completare la formazione, aprire il ",
      errorForNoCOC_2: "Centro di formazione Adobe Channel",
      errorForNoCOC_3:
        " utilizzando il link fornito sotto la tabella. Una volta completata la formazione, fare clic sul pulsante REFRESH per aggiornare lo stato di completamento del corso dei contatti.",
      logInCPButton: "Accedi a Captivate prime",
      refresh: "Aggiornare",
      course_completed_ff:
        "Corsi di formazione completati (Seleziona tutte le risposte applicabili)",
      Register: "Registrati",
      "Contact Helpdesk": "Contatta l'help desk",

      prog_agmt_checkbox:
        "HO LETTO, COMPRESO E ACCETTATO DI RISPETTARE I TERMINI E LE CONDIZIONI QUI INDICATI E DICHIARO E GARANTISCO DI ESSERE AUTORIZZATO A VINCOLARE IL RIVENDITORE.",
      ConsolePartnerAccountListPartnerFinder:
        "Elenco in sistema di rilevamento rivenditore (?)",
      ConsolePartnerContactHeader: "Contatti",

      thank_you: "Grazie.",
      ConsolePartnerConActive: "Attivo",
      Return_to_Adobe_Channel_Partners: "Adobe Partner Connection",
      "Continue Enrollment": "iscrizione",
      problem_header: "Si è verificato un problema.",
      sign_in: "Accedi con Adobe ID",
      associated_other_account:
        "L’Adobe ID con cui hai effettuato l'accesso (%{email}) è già associato a un altro programma per i partner Adobe: %{program}. Per continuare la registrazione, prova ad accedere con un altro Adobe ID oppure contatta l'help desk.",
      OnbrdGenInvalidTokenErrMsg:
        "Il collegamento è già scaduto. Contattare l'help desk.",
    },
  },
  ja_JP: {
    uplevelRenewal: {
      PP_Adobe_Portal: null,
      PP_APC_Header_Label: null,
      ONBUplevelInfo: "ご希望のレベルを選択してください。",
      ONBNewLevel: "新しいレベル",
      OnbrdInterimUplevelHeader: "申請を希望するレベルを選択してください。",
      OnbrdGenCertifiedLevel: "サーティファイド",
      OnbrdGenGoldLevel: "ゴールド",
      OnbrdGenErrorLabel: "エラー：",
      OnbrdGenInputErrorMsg: "値を入力してください。",
      NAUplevelProgramType: null,
      NAUplevelRetailSpecialization: null,
      OnbrdInterimSelectButton: "選択",

      ctr1_certified:
        "リセラー様は、オンラインエンロールメントを完了し、取引条件及び契約条件にご承諾して頂く必要があります。",
      ctr2_certified:
        "リセラー様におかれましては、ご希望されるレベルの必要条件をすべて満たしていただく必要があります。必要条件に関する詳細は、プログラムガイドをご参照ください。",
      ctr1_gold:
        "リセラー様は、オンラインエンロールメントを完了し、取引条件及び契約条件にご承諾して頂く必要があります。",
      ctr2_gold:
        "リセラー様におかれましては、ご希望されるレベルの必要条件をすべて満たしていただく必要があります。必要条件に関する詳細は、プログラムガイドをご参照ください。",

      PP_APC_Header_Label: null,
      OnbrdCriteriaAuthoriseMsg:
        "お客様が、組織を代表して申請することが許可されていることを確認する箇所にチェックを入れてください。",
      OnbrdTermsPartnerCodeMsg:
        "条件とアドビ　ビジネスパートナーの行動規範を確認し、承諾の確認を示す箇所にチェックを入れてください。",
      OnbrdContactPrefLang: "優先される言語 *",
      PP_Adobe_Portal: null,
      ONBLangPref: "地域と言語",
      OnbrdCriteriaHeader: "登録の基準",
      OnbrdCriteriaHeaderRenewal: "更新の基準",
      OnbrdCriteriaHeaderUplevel: "アップレベルの基準",
      ONBCompInfo: "会社情報",
      ONBContsInfo: "連絡先情報",
      SplznQuestionnaireHeader: "質問事項",
      ONBPgmAgreement: "プログラム契約",
      ONBPreferredLanguage:
        "お客様の組織の所在地と設定言語を選択してください。",
      OnbrdProfileRegion: "地域",
      OnbrdGenSelectErrorMsg: "値を選択してください。",
      OnbrdProfileCountry: "国（半角英数字）",
      OnbrdGenNone: "なし",
      ONBRegCriteriaAgree: "登録条件を確認し、同意してください。",
      OnbrdCriteriaBody:
        "リセラープログラムに、ご興味をお持ちいただき有り難うございます。",
      OnbrdCriteriaBodyRenewal:
        "リセラープログラムのメンバーシップの更新に、ご興味を持っていただき有り難うございます。",
      OnbrdCriteriaBodyUplevel:
        "リセラープログラムのメンバーシップのアップグレードに、ご興味を持っていただき有り難うございます。",
      OnbrdCriteriaBody1:
        "オンライン登録手続により、メンバーシップを申請できます。 リセラープログラムのご希望レベルでの必須要件、ならびに、下記の登録基準をご確認ください。 手続の準備が整いましたら、お客様がこの登録を申請する権限を与えられていることを確認してください。",
      OnbrdCriteriaSectionHeader: "登録の基準",
      OnbrdCriteriaSectionHeaderRenewal: "更新の基準",
      OnbrdCriteriaSectionHeaderUplevel: "アップレベルの基準",
      OnbrdCriteriaAuthorized: "会社の経営責任者です。",
      OnbrdCriteriaAuthorized2:
        "または、経営責任者からこの登録申請の許可を明示的に受けている人物です。",
      ONBEnterCompDetails: "お客様の組織に関する以下の情報をご記入ください。",
      OnbrdProfileMembershipId: "メンバーシップID",
      OnbrdProfileParentMembershipId: "親メンバーシップID",
      OnbrdProfileContractStart: "契約開始日",
      OnbrdProfilePartnerLevel: "パートナーのレベル",
      OnbrdProfileContractEnd: "契約の終了日",
      OnbrdProfileSplzn: "専門分野",
      OnbrdProfileAcctMgr: "アカウントマネージャー",
      OnbrdProfileAddLicenses: "＃追加ライセンス",
      OnbrdProfileFullCompName: "会社の正式名称  （英語/半角英数字）",
      OnbrdGenInputErrorMsg: "値を入力してください。",
      OnbrdProfileTradingName: "会社の正式名称  （日本語",
      OnbrdProfileBRN: "法人番号",
      OnbrdProfilePreferredDistributor: "発注先パートナー（英語/半角英数字）",
      OnbrdProfileYrIncorp: "創設年 *",
      OnbrdGenInvalidYrFormat: "年は次の形式で入力してください: YYYY",
      OnbrdGenInvalidYr: "無効な年",
      OnbrdGenInvalidFutureDateMsg:
        "日付は、後に設定されます。 有効な日付を入力してください。",
      OnbrdProfileCompType: "会社の種類 (複数回答可) *",
      OnbrdGenSelectErrorMsg: "値を選択してください。",
      OnbrdProfileCountry: "国（半角英数字）",
      OnbrdGenNone: "なし",
      OnbrdProfileStreet: "番地（半角英数字）*",
      OnbrdProfileCity: "市町村（半角英数字）*",
      OnbrdProfileState: "都道府県（半角英数字）*",
      OnbrdProfilePostCode: "郵便番号（半角英数字）*",
      OnbrdProfilePrimPhone: "代表電話番号（半角英数字）*",
      OnbrdProfilePrimFax: "代表ファックス番号（半角英数字）",
      OnbrdProfileContactEmail: "Eメールアドレス（半角英数字）*",
      OnbrdGenEmailFormatErrMsg: "Eメールの形式が無効です。",
      OnbrdProfileCompanyDomainMsg:
        "入力された会社のEメールのドメインは、主担当者のメールドメインと一致しません。",
      OnbrdProfileEmailDomain: "Eメールのドメイン",
      OnbrdProfilePrimURL: "ウェブサイト（半角英数字）*",
      OnbrdProfileSecondaryURL: "ECウェブサイト（半角英数字）",
      OnbrdProfileListPartnerFinder:
        "リセラーファインダーに掲載希望場合はチェック",
      ONBContactDetails: "お客様の組織の連絡先情報をご記入ください。",
      OnbrdContactSecContactInfo: "担当者情報",
      OnbrdContactSectionHeader:
        "組織の担当者情報を入力してください。<BR/>\n注意：プライマリ（第一）担当者とセカンダリ（第二）担当者が必要です。その他の担当者を追加していただくとも可能です。",
      ONBAddSecBtn: "第2連絡先を追加",
      ONBAddOtherBtn: "その他の連絡先を追加",
      ReAssignContactNameLabel: "担当社の氏名",
      ConsolePartnerContactEmail: "Eメール",
      ConsolePartnerContactCType: "主担当者タイプ",
      TrngManage: "管理",
      OnbrdContactPrimaryType: "第一",
      OnbrdContactSecondaryType: "第二",
      OnbrdContactOtherType: "その他",
      ConsolePartnerBtnEdit: "編集",
      QBPDelete: "削除",
      OnbrdContactPriConHeader: "プライマリ（第一）担当者",
      OnbrdContactSecConHeader: "セカンダリ（第二）",
      OnbrdContactOther: "他の担当者",
      OnbrdContactPrefix: "部署名",
      OnbrdContactTitle: "役職",
      prefixMaxLengthError:
        "Prefix must be 10 characters or fewer, Kindly update.",
      suffixMaxLengthError:
        "Suffix must be 10 characters or fewer, Kindly update.",
      OnbrdContactFName: "名 (英語) *",
      OnbrdContactLName: "姓（英語）*",
      OnbrdContactPhone: "電話（半角）*",
      OnbrdContactJRole: "役割 *",
      OnbrdContactEmail: "メール *",
      OnbrdContactAddtlType: "タイプ",
      OnbrdContactDeactivate: "無効化",
      OnbrdContactDeactivateHelp:
        "「無効化」ボックスにチェックを入れると、担当者がアカウントから削除されます。 この担当者は、アドビ　システムにアクセスできなくなります。",
      TrngSaveClose: "保存して閉じる",
      TrngClose: "閉じる",
      ONBRegCerContacts:
        "Please select and complete the required COC training course before submitting your request.",
      OnbrdCertContactSectionHeader:
        "ご希望のレベルに達するにはセールストレーニングが必要です。少なくとも1名は「パートナーの行動規範」トレーニングを完了する必要があります。トレーニング要件の一覧については、Adobe Partner Connectionリセラー/リテールプログラムガイドをご覧ください。下のフィールドで、必須トレーニングを完了した人の問い合わせ先を確認できます。",
      OnbrdContactAdd: "担当者の追加",
      OnbrdCertContactFName: "名 (英語)",
      OnbrdCertContactLName: "姓（英語）",
      OnbrdCertContactEmail: "メール",
      OnbrdCertContactCertification: "完了済みトレーニング",
      TrngManage: "管理",
      ConsolePartnerBtnEdit: "編集",
      ONBCerContactDetails: "認定担当者の詳細",
      OnbrdCertContactDeactivated: "無効化",
      ONBRetailSplQues: "リテールプログラムの専門化アンケート",
      OnbrdPrimaryQuestionnaireHeader: "コンプライアンスに関する質問事項",
      OnbrdSecondaryQuestionnaireHeader: "さらなる質問事項",
      OnbrdPartnerFinderInfoHeader: "企業概要に関する質問事項",
      ONBAgreeToSubmit: "プログラム契約を確認し、同意してください。",
      OnbrdTermsSectionHeader2:
        "リセラープログラムのメンバーシップ規約を確認し、指示する個所で承諾の確認を行ってください。",
      OnbrdTermsSectionHeader: "メンバーシップ規約",
      OnbrdTermsAccept:
        "I HAVE READ, UNDERSTOOD, AND AGREED TO COMPLY WITH THE TERMS AND CONDITIONS INDICATED HEREIN AND REPRESENT AND WARRANT THAT I AM AUTHORIZED TO BIND THE RESELLER.",
      OnbrdThankYouNewRegistered:
        "<BR/>リセラープログラムに、ご興味をお持ちいただき有り難うございます。 お申し込みを受理いたしました。 まもなくお客様宛に、確認のEメールが送信されます。 お申込みに関する最新情報は、引き続きEメールにてお知らせいたします。<BR/>",
      OnbrdThankYouRenewalRegistered:
        "お客様の更新情報が登録されました。　まもなくお客様宛にご確認のメールが送信されます。登録に関する最新情報は別途メールにてお知らせ致します。",
      OnbrdThankYouRenewalCertGold:
        "お客様の更新情報が登録されました。　まもなくお客様宛にご確認のメールが送信されます。登録に関する最新情報は別途メールにてお知らせ致します。",
      OnbrdThankYouUplevelCertGold:
        "リセラープログラムの新レベルへのアップグレードに、ご興味を持っていただき有り難うございます。 新レベルへの御申し込みを受理致しました。 まもなくお客様宛に、確認のEメールが送信されます。 については、引き続きEメールにてお知らせいたします。",
      OnbrdThankYouClick: "クリックして",
      OnbrdThankYouEducURL:
        "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=Education&id=",
      OnbrdThankYouHere: "こちらで",
      OnbrdThankYouEd: "教育の専門科目を更新してください。",
      OnbrdThankYouLegalURL:
        "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=SAM+services&id=",
      OnbrdThankYouLeg: "SAMサービス専門科目の更新を行います。",
      OnbrdThankYouProVedioURL: null,
      OnbrdThankYouPv: null,
      OnbrdThankYouGovURL: null,
      OnbrdThankYouGv: null,
      OnbrdThankYouDpsURL: null,
      OnbrdThankYouDps: null,
      OnbrdThankYouHelpDesk:
        "ご質問がある場合、パートナーヘルプデスクまでご連絡ください。",
      OnbrdErrorUnauthorized:
        "申し訳ございません。お客様は、このページを閲覧する権限が与えられておりません。 登録、アップレベルについてヘルプは、パートナーヘルプデスクにお問合せください。",
      OnbrdErrorNewRegEmailExist:
        "<BR/><BR/>\n<p>お客様のEメールアドレスがシステム中に既に存在するため、登録を処理できませんでした。</p>\n<BR/><BR/><BR/><BR/><BR/>",
      OnbrdErrorNewRegEmailFree:
        "<BR/><BR/> \n<p>無料のメールドメイン、ならびに、ISPは、会社ならびに主担当者のメールドメインとして、認められておりません。 会社のメールアドレスでアドビIDを取得してください。</p> \n<BR/><BR/><BR/><BR/><BR/>",
      OnbrdErrorExpiredLink:
        "<BR/><BR/>\n<p>リンクの期限が切れています。 パートナーのヘルプデスクにお問合せください。</p>\n<BR/><BR/><BR/><BR/><BR/>",
      OnbrdInterimUplevelExistsMsg:
        "Adobe Partner Connectionプログラムのアップレベルにご興味をお持ちいただきありがとうございます。ご提出いただいたアップレベル申請書を現在審査しております。お客様の申請に関する最新情報を電子メールでお知らせいたします。",
      OnbrdProgNextStepExistMsg:
        "このリセラー様は、リセラープログラムに、すでに登録されています。 下の「Eメールを送信」ボタンをクリックして、お客様が、このプログラムでの参加に関心のあるリセラー様をお知らせください。",
      OnbrdGenPreviousLabel: "前のページ",
      OnbrdGenSaveExitLabel: "保存して終了する。",
      OnbrdGenSubmitLabel: "送信",
      OnbrdGenNextLabel: "次へ",
      OnbrdPartnerFinderProdExpOther:
        "過去取扱製品　－　他社製品: （全角127文字以内）",
      OnbrdPrimaryQuestionnaireSectionHeader:
        "会社に関する以下の質問に対して答えてください。",
      renewal_unauthorized:
        "申し訳ございません。お客様は、このページを閲覧する権限が与えられておりません。",

      OnbrdPartnerFinderInfoBusProfSection: "事業プロフィール",
      OnbrdPartnerFinderSSCountriesAmerica: "販売/サポート国（米州）",
      OnbrdPartnerFinderSSCountriesEurope:
        "販売/サポート国（ヨーロッパ　/　アジア） 日本のリセラー様はこちらで日本のみを選択してください",
      OnbrdPartnerFinderSSCountriesAfrica: "販売/サポート国（アフリカ/ME）",
      OnbrdPartnerFinderSSCountiresAsia: "販売/サポート国（アジア太平洋）",
      OnbrdPartnerFinderBusinessDescEng: "事業内容（英語）",
      OnbrdLengthValidationErrorMsg: null,
      OnbrdPartnerFinderAltLang: "代替言語",
      OnbrdPartnerFinderBusinessDescOther: "事業内容（他言語）",
      OnbrdPartnerFinderOrgSizeSection: "組織のサイズ",
      OnbrdPartnerFinderTotalEmp: "総従業員数",
      OnbrdPartnerFinderTotInsideTelSFDC: "内勤/電話による販売員の総数",
      OnbrdPartnerFinderTotOutsideDirSFDC: "外勤　/　直接販売員の総数",
      OnbrdPartnerFinderTotTechProfOnStaff: "技術専門職の総数",
      OnbrdPartnerFinderTotDevOnStaff: "開発者総数",
      OnbrdPartnerFinderTotMarkProfOnStaff: "マーケティング専門職の総数",
      OnbrdPartnerFinderCustSegmentSection: "顧客セグメント",
      OnbrdPartnerFinderPrimFocus: "第一販売先",
      OnbrdGenErrorLabel: "エラー：",
      AcctCustomerSegmentErrorMsg:
        "選択された値は、顧客セグメントのグループ内で、一意的である必要があります。",
      OnbrdPartnerFinderSecFocus: "第二販売先",
      OnbrdPartnerFinderNotSig: "その他",
      OnbrdPartnerFinderProdExpSection: "過去取扱製品",
      OnbrdPartnerFinderProdExpAdobe: "過去取扱製品　－　アドビ",
      OnbrdPartnerFinderProdExpOther:
        "過去取扱製品　－　他社製品: （全角127文字以内）",
      OnbrdPartnerFinderProductSoldSection: "現在の取扱製品",
      OnbrdPartnerFinderProdSoldAdobe: "現在の取扱製品　－　アドビ",
      OnbrdPartnerFinderProdExpSoldOther:
        "現在の取扱製品　－　他社製品: （全角127文字以内）",
      OnbrdPartnerFinderSrvcOfferedSection: "業務内容",
      AcctServicesOfferedErrorMsg:
        "選択された値は、サービスを提供したグループ内で、一意的である必要があります。",
      OnbrdPartnerFinderVerticalFocusSection: "顧客分類",
      OnbrdPartnerFinderVertGovError:
        "リストから、官公庁の値を選択出来ません。",
      OnbrdPartnerFinderVertEducError:
        "リストから、教育機関の値を選択出来ません。",
      AcctVerticalSegmentErrorMsg:
        "選択された値は、垂直的に統合されたセグメントのグループ内で、一意的である必要があります。",
      Previous: "前のページ",
      "Save and Exit": "保存して終了する。",
      Submit: "送信",
      Next: "次へ",

      select_level: "レベルを選択",
      basic_comp_info: "基本会社情報",
      location: "所在地",
      comp_email_address: "会社の電子メールアドレス *",
      save_n_exit_body:
        "登録プロセスを完了する準備ができたらいつでも戻ってきてください。前回終了した時点から再開できます。これでこのブラウザーウィンドウを閉じるか、別のwebサイトに移動できます。",
      contact_type: "連絡先の種類 (複数回答可) *",
      confirm_deletion: "削除を確認",
      delete_confirm_msg: "連絡先「 ",
      delete_confirm_msg1: "」を削除してもよろしいですか？",
      prog_agmt_text:
        "あと少しで完了です。最後にPartner Connectionプログラムの販売代理店契約書をお読みください。該当する箇所で、承諾の意思をご確認ください。",
      add: "追加",
      Select: "選択",
      select_all_that_apply: "複数回答可",
      i_certify: "私は、以下の事項を証明します。",
      msg_saving_data: "フォームのデータを保存中",
      msg_data_saved: "データは保存されました。",
      add_certified_contacts: "認定連絡先を追加",
      add_certified_msg:
        "認定連絡先の詳細を以下に追加してください。次に「保存」をクリックしてください。",
      course_completed: "研修コース完了 ",
      course_completed_COC: "行動規範トレーニング　ステータス",
      errorForNoCOC_1:
        "申請を進めるには、少なくとも1人がパートナー行動規範トレーニングを完了する必要があります。トレーニングを完了するには、表の下にあるリンクを使用して ",
      errorForNoCOC_2: "Adobe Channelトレーニングセンタ",
      errorForNoCOC_3:
        "ーを開いてください。トレーニングを完了したら、[リフレッシュ（更新)]ボタンをクリックして、コース完了ステータスを確認してください。",
      logInCPButton: "captivate primeにログインください.",
      refresh: "リフレッシュ",
      course_completed_ff: "研修コース完了 (複数回答可)",
      Register: "登録",
      "Contact Helpdesk": "ヘルプデスクに連絡",

      prog_agmt_checkbox:
        "I HAVE READ, UNDERSTOOD, AND AGREED TO COMPLY WITH THE TERMS AND CONDITIONS INDICATED HEREIN AND REPRESENT AND WARRANT THAT I AM AUTHORIZED TO BIND THE RESELLER.",
      ConsolePartnerAccountListPartnerFinder:
        "パートナーファインダーに掲載しますか（？）",
      ConsolePartnerContactHeader: "担当者",

      thank_you: "ありがとうございます。",
      ConsolePartnerConActive: "有効",
      Return_to_Adobe_Channel_Partners: "Adobe Partner Connection",
      "Continue Enrollment": "登録を続ける",
      problem_header: "問題が発生しました。",
      sign_in: "Adobe IDでログイン",
      associated_other_account:
        "(%{email})でログインしたAdobe IDは、既に別のアドビパートナープログラム%{program}と関連付けられています。別のAdobe IDでログインするか、ヘルプデスクに連絡して登録を続けることができます。",
      OnbrdGenInvalidTokenErrMsg:
        "リンクの期限が切れています。 ヘルプデスクまでご連絡ください。",
    },
  },
  ko_KR: {
    uplevelRenewal: {
      PP_Adobe_Portal: null,
      PP_APC_Header_Label: null,
      ONBUplevelInfo: "원하는 레벨을 선택하십시오.",
      ONBNewLevel: "새로운 레벨",
      OnbrdInterimUplevelHeader: "귀사가 신청하려는 등급을 선택하십시오.",
      OnbrdGenCertifiedLevel: null,
      OnbrdGenGoldLevel: null,
      OnbrdGenErrorLabel: "오류:",
      OnbrdGenInputErrorMsg: "값을 입력하십시오.",
      NAUplevelProgramType: null,
      NAUplevelRetailSpecialization: null,
      OnbrdInterimSelectButton: "선택",

      ctr1_certified:
        "리셀러는 이 온라인 양식을 작성하고 리셀러 프로그램 약관에 동의해야 합니다.",
      ctr2_certified:
        "리셀러는 업그레이드하려는 등급의 모든 기준을 충족해야 합니다. 자격 조건에 대한 자세한 내용은 Adobe Partner Connection Reseller Program Guide를 참조하십시오.",
      ctr1_gold:
        "리셀러는 이 온라인 양식을 작성하고 리셀러 프로그램 약관에 동의해야 합니다.",
      ctr2_gold:
        "리셀러는 업그레이드하려는 등급의 모든 기준을 충족해야 합니다. 자격 조건에 대한 자세한 내용은 Adobe Partner Connection Reseller Program Guide를 참조하십시오.",

      PP_APC_Header_Label: null,
      OnbrdCriteriaAuthoriseMsg:
        "표시된 곳에 체크 표시하여 귀하가 조직 대신 이 신청서를 작성할 수 있는 권한을 가지고 있음을 확인하십시오.",
      OnbrdTermsPartnerCodeMsg:
        "이 약관과 Adobe 비즈니스 파트너 행동 강령을 숙지한 다음 해당 상자에 체크 표시하여 귀사의 동의를 확인하십시오.",
      OnbrdContactPrefLang: "기본 언어 *",
      PP_Adobe_Portal: null,
      ONBLangPref: "지역 및 언어",
      OnbrdCriteriaHeader: "등록 기준",
      OnbrdCriteriaHeaderRenewal: "갱신 기준",
      OnbrdCriteriaHeaderUplevel: "등급 상승 기준",
      ONBCompInfo: "회사 정보",
      ONBContsInfo: "담당자 정보",
      SplznQuestionnaireHeader: "설문 조사",
      ONBPgmAgreement: "프로그램 계약서",
      ONBPreferredLanguage: "귀사의 위치와 기본 언어를 선택하십시오.",
      OnbrdProfileRegion: "지역",
      OnbrdGenSelectErrorMsg: "값을 선택하십시오.",
      OnbrdProfileCountry: "국가",
      OnbrdGenNone: "--없음--",
      ONBRegCriteriaAgree: "등록 기준을 검토하고 동의 여부를 선택하십시오.",
      OnbrdCriteriaBody:
        "Adobe Partner Connection Reseller Program에 대한 많은 관심을 보여주셔서 감사합니다.",
      OnbrdCriteriaBodyRenewal:
        "Adobe Partner Connection Reseller Program의 멤버십 갱신에 많은 관심을 보여주셔서 감사합니다.",
      OnbrdCriteriaBodyUplevel:
        "Adobe Partner Connection Reseller Program의 멤버십 업그레이드에 많은 관심을 보여주셔서 감사합니다.",
      OnbrdCriteriaBody1:
        "귀사의 멤버십 가입 과정은 이 온라인 등록 과정부터 시작합니다. 아래 원하는 멤버십 등급에 해당하는 Reseller Program 조건과 등록 기준을 검토하십시오. 가입 준비가 모두 완료되면 귀하가 본 신청서를 작성할 수 있는 권한을 가지고 있는지 확인하십시오. 그런 다음 계속하려면 다음을 클릭하십시오.",
      OnbrdCriteriaSectionHeader: "등록 기준",
      OnbrdCriteriaSectionHeaderRenewal: "갱신 기준",
      OnbrdCriteriaSectionHeaderUplevel: "등급 상승 기준",
      OnbrdCriteriaAuthorized:
        "회사의 최고 경영자 또는 총괄 책임자입니다. 또는",
      OnbrdCriteriaAuthorized2:
        "경영진 또는 이사진으로부터 회사를 대표하여 본 신청서를 작성할 수 있는 권한을 위임 받았습니다.",
      OnbrdProfileMembershipId: "멤버십 ID",
      OnbrdProfileParentMembershipId: "상위 멤버십 ID",
      OnbrdProfileContractStart: "계약 시작일",
      OnbrdProfilePartnerLevel: "파트너 등급",
      OnbrdProfileContractEnd: "계약 종료일",
      OnbrdProfileSplzn: "전문 파트너",
      OnbrdProfileAcctMgr: "계정 관리자",
      OnbrdProfileAddLicenses: "추가 액세스 권한 수",
      OnbrdProfileFullCompName: "회사 이름(영어)",
      OnbrdGenInputErrorMsg: "값을 입력하십시오.",
      OnbrdProfileTradingName: "회사 이름(한글)",
      OnbrdProfileBRN: "사업자 등록번호",
      OnbrdProfilePreferredDistributor: "선호 총판(영어)",
      OnbrdProfileYrIncorp: "설립 연도 *",
      OnbrdGenInvalidYrFormat: "연도 포맷을 따르십시오: YYYY",
      OnbrdGenInvalidYr: "잘못된 연도",
      OnbrdGenInvalidFutureDateMsg:
        "날짜가 미래로 설정되었습니다. 올바른 날짜를 입력하십시오.",
      OnbrdProfileCompType: "회사 유형 (해당 사항을 모두 선택하십시오) *",
      OnbrdProfileStreet: "주소(영어) *",
      OnbrdProfileCity: "구/군/시(영어) *",
      OnbrdProfileState: "도 *",
      OnbrdProfilePostCode: "우편 번호 *",
      OnbrdProfilePrimPhone: "기본 전화 *",
      OnbrdProfilePrimFax: "기본 팩스 번호",
      OnbrdProfileContactEmail: "이메일 주소 *",
      OnbrdGenEmailFormatErrMsg: "잘못된 이메일 포맷.",
      OnbrdProfileCompanyDomainMsg:
        "귀사가 입력한 회사 이메일 도메인은 기본 담당자의 이메일 도메인과 일치하지 않습니다.",
      OnbrdProfileEmailDomain: "이메일 도메인",
      OnbrdProfilePrimURL: "웹 사이트 *",
      OnbrdProfileSecondaryURL: "추가 웹 사이트",
      OnbrdProfileListPartnerFinder: "리셀러 찾기 목록에 등록하시겠습니까?",
      ONBContactDetails: "귀사의 담당자 정보를 제공하십시오.",
      OnbrdContactSecContactInfo: "담당자 정보",
      OnbrdContactSectionHeader:
        "귀사의 담당자 정보를 제공하십시오.<br/>\n참고: 기본 및 추가 담당자 정보를 모두 입력해야 합니다. Adobe가 세일즈, 마케팅 및 기술 업데이트와 관련하여 귀사에 연락할 수 있도록 담당자를 추가할 수 있습니다.",
      ONBAddSecBtn: "추가 담당자 추가",
      ONBAddOtherBtn: "다른 담당자 추가",
      ReAssignContactNameLabel: "담당자 이름",
      ConsolePartnerContactEmail: "이메일",
      ConsolePartnerContactCType: "주요 담당자 유형",
      TrngManage: "관리",
      OnbrdContactPrimaryType: "기본",
      OnbrdContactSecondaryType: "추가",
      OnbrdContactOtherType: "기타",
      ConsolePartnerBtnEdit: "수정",
      QBPDelete: "삭제",
      OnbrdContactPriConHeader: "기본 담당자",
      OnbrdContactSecConHeader: "추가 담당자",
      OnbrdContactOther: "다른 담당자",
      OnbrdContactPrefix: "경칭",
      OnbrdContactTitle: "호칭/칭호",
      prefixMaxLengthError:
        "Prefix must be 10 characters or fewer, Kindly update.",
      suffixMaxLengthError:
        "Suffix must be 10 characters or fewer, Kindly update.",
      OnbrdContactFName: "이름 *",
      OnbrdContactLName: "성 *",
      OnbrdContactPhone: "전화 *",
      OnbrdContactJRole: "직무 *",
      OnbrdContactEmail: "이메일 *",
      OnbrdContactAddtlType: "유형",
      OnbrdContactDeactivate: "비활성화",
      OnbrdContactDeactivateHelp:
        "비활성화 상자에 체크 표시를 하면 계정에서 이 담당자가 삭제되고 이 담당자는 더 이상 Adobe 시스템에 액세스할 수 없습니다.",
      TrngSaveClose: "저장하고 닫기",
      TrngClose: "닫기",
      ONBRegCerContacts:
        "Please select and complete the required COC training course before submitting your request.",
      OnbrdCertContactSectionHeader:
        '원하는 레벨을 획득하려면 세일즈 트레이닝이 필요합니다. 최소 한 명이 "파트너 행동 강령" 트레이닝을 이수해야 합니다. 트레이닝 요구 사항에 대한 전체 목록은 Adobe Partner Connection Reseller 또는 Retail 프로그램 가이드를 참조하십시오. 아래 필드에서 필수 트레이닝을 이수한 담당자를 확인할 수 있습니다.',
      OnbrdContactAdd: "다른 담당자 추가",
      OnbrdCertContactFName: "이름",
      OnbrdCertContactLName: "성",
      OnbrdCertContactEmail: "이메일",
      OnbrdCertContactCertification: "이수한 교육 과정",
      TrngManage: "관리",
      ONBCerContactDetails: "공인 담당자 세부 정보",
      OnbrdCertContactDeactivated: "비활성화",
      ONBRetailSplQues: "소매 프로그램 전문화 설문지",
      OnbrdPrimaryQuestionnaireHeader: "등록에 대한 규정 준수 설문 조사",
      OnbrdSecondaryQuestionnaireHeader: "등록에 대한 추가 설문 조사",
      OnbrdPartnerFinderInfoHeader: "등록에 대한 비즈니스 설문 조사",
      ONBAgreeToSubmit: "프로그램 계약서를 검토하고 동의 여부를 선택하십시오.",
      OnbrdTermsSectionHeader2:
        "Reseller Program 약관을 숙지하십시오. 스크롤 다운한 다음 해당 상자를 클릭하여 귀사의 동의를 확인하셔야 합니다.",
      OnbrdTermsSectionHeader: "약관",
      OnbrdTermsAccept:
        "본 문서에 명시된 약관을 읽고 이해했으며 이 약관을 준수할 것에 동의합니다. 그리고 리셀러를 구속할 수 있는 권한을 부여 받았음을 진술하고 보장합니다.<BR/><BR/>",
      OnbrdThankYouNewRegistered:
        "<br/>\nAdobe Partner Connection Reseller Program에 많은 관심을 보여주셔서 감사합니다. 귀사가 제출한 신청서를 접수했으며 확인 이메일이 곧 전송됩니다. 귀사의 신청서와 관련하여 업데이트된 사항이 있으면 이메일을 통해 통보해 드리겠습니다.<br/><br/>",
      OnbrdThankYouRenewalRegistered:
        "귀사의 갱신 신청서가 제출되었으며 확인 이메일이 곧 전송됩니다.",
      OnbrdThankYouRenewalCertGold:
        "귀사의 갱신 신청서가 제출되었으며 확인 이메일이 곧 전송됩니다.",
      OnbrdThankYouUplevelCertGold:
        "Adobe Partner Connection Reseller Program에서 새 등급으로 업그레이드하는 데 많은 관심을 보여주셔서 감사합니다. 귀사가 제출하신 새 등급 신청서를 접수했으며 확인 이메일이 곧 전송됩니다. 귀사의 신청서와 관련하여 업데이트된 사항이 있으면 이메일을 통해 통보해 드리겠습니다.",
      OnbrdThankYouClick: "클릭하십시오.",
      OnbrdThankYouEducURL:
        "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=Education&id=",
      OnbrdThankYouHere: "여기를",
      OnbrdThankYouEd: "귀사의 교육 기관 전문 파트너를 갱신하려면",
      OnbrdThankYouLegalURL:
        "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=SAM+services&id=",
      OnbrdThankYouLeg: "귀사의 SAM 서비스 전문 파트너를 갱신하려면",
      OnbrdThankYouProVedioURL:
        "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=ProVideo&id=",
      OnbrdThankYouPv: "귀사의 프로비디오 전문 파트너를 갱신하려면",
      OnbrdThankYouGovURL:
        "http://adobedealreg.sfqa.cs12.force.com/Onboarding/SplznWizardPage?sp=Government&id=",
      OnbrdThankYouGv: "귀사의 공공 기관 전문 파트너를 갱신하려면.",
      OnbrdThankYouDpsURL:
        "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=DigitalPublishingSuite&id=",
      OnbrdThankYouDps: null,
      OnbrdThankYouHelpDesk:
        "지원이 필요한 경우 Adobe Partner Connection 헬프 데스크에 문의하십시오.",
      OnbrdErrorUnauthorized:
        "죄송합니다. 이 페이지를 볼 수 있는 권한이 없습니다. 등록/등급 상승에 대한 자세한 내용은 파트너 헬프 데스크에 문의하십시오.",
      OnbrdErrorNewRegEmailExist:
        "<br/><br/>\n<p>귀하의 이메일이 시스템에 이미 존재하므로 등록을 처리할 수 없습니다.</p>\n<br/><br/><br/><br/><br/>",
      OnbrdErrorNewRegEmailFree:
        "<br/><br/> \n<p>무료 이메일 도메인과 ISP는 회사 및 기본 담당자 이메일 도메인으로 허용되지 않습니다. 기업 이메일 계정을 사용해 Adobe ID를 신청하십시오.</p> \n<br/><br/><br/><br/><br/>",
      OnbrdErrorExpiredLink:
        "<br/><br/>\n<p>귀사의 링크가 이미 만료되었습니다. 파트너 헬프 데스크에 문의하십시오.</p>\n<br/><br/><br/><br/><br/>",
      OnbrdInterimUplevelExistsMsg:
        "Adobe Partner Connection Program에서 새로운 등급으로 업그레이드하는 데 관심을 보여주셔서 감사합니다. 이전에 제출하신 새로운 등급에 대한 신청서는 이미 검토 중입니다. 귀하의 신청서와 관련해 업데이트되는 내용이 있는 경우 이메일을 통해 알려 드릴 것입니다.",
      OnbrdProgNextStepExistMsg:
        "이 리셀러는 Adobe Partner Connection Reseller Program에 이미 등록되어 있습니다. 아래 이메일 보내기 버튼을 클릭하여 이 프로그램 참여에 대한 귀사의 관심을 이 리셀러에게 알릴 수 있습니다.",
      OnbrdGenPreviousLabel: "이전",
      OnbrdGenSaveExitLabel: "저장 및 나가기",
      OnbrdGenSubmitLabel: "제출",
      OnbrdGenNextLabel: "다음",
      OnbrdPartnerFinderProdExpOther: "제품 전문 지식 - 기타[최대 255자]",
      OnbrdPrimaryQuestionnaireSectionHeader:
        "귀사에 대한 다음 질문에 응답하십시오.",
      ONBEnterCompDetails: "회사 정보",
      renewal_unauthorized:
        "죄송합니다. 이 페이지를 볼 수 있는 권한이 없습니다.",

      OnbrdPartnerFinderInfoBusProfSection: "비즈니스 프로필",
      OnbrdPartnerFinderSSCountriesAmerica: "세일즈/지원 국가(북남미)",
      OnbrdPartnerFinderSSCountriesEurope: "세일즈/지원 국가(유럽/아시아)",
      OnbrdPartnerFinderSSCountriesAfrica: "세일즈/지원 국가(아프리카/중동)",
      OnbrdPartnerFinderSSCountiresAsia: "세일즈/지원 국가(아시아 태평양)",
      OnbrdPartnerFinderBusinessDescEng: "비즈니스 설명(영어) [최대 255자]",
      OnbrdLengthValidationErrorMsg: "최대 255자를 입력하십시오.",
      OnbrdPartnerFinderAltLang: "대체 언어",
      OnbrdPartnerFinderBusinessDescOther: "비즈니스 설명(한글) [최대 255자]",
      OnbrdPartnerFinderOrgSizeSection: "조직 규모",
      OnbrdPartnerFinderTotalEmp: "총 직원 수",
      OnbrdPartnerFinderTotInsideTelSFDC: "총 사내/전화 영업 직원 수",
      OnbrdPartnerFinderTotOutsideDirSFDC: "총 사외/다이렉트 영업 직원 수",
      OnbrdPartnerFinderTotTechProfOnStaff: "총 사내 기술 전문가 수",
      OnbrdPartnerFinderTotDevOnStaff: "총 정규 개발자 수",
      OnbrdPartnerFinderTotMarkProfOnStaff: "총 정규 마케팅 전문가 수",
      OnbrdPartnerFinderCustSegmentSection: "고객 분류",
      OnbrdPartnerFinderPrimFocus: "주력 분야",
      OnbrdGenErrorLabel: "오류:",
      AcctCustomerSegmentErrorMsg:
        "선택한 값은 고객 분류 그룹에서 고유해야 합니다.",
      OnbrdPartnerFinderSecFocus: "2차 주력 분야",
      OnbrdPartnerFinderNotSig: "중요하지 않음",
      OnbrdPartnerFinderProdExpSection: "제품 전문 지식",
      OnbrdPartnerFinderProdExpAdobe: "제품 전문 지식 - Adobe",
      OnbrdPartnerFinderProdExpOther: "제품 전문 지식 - 기타[최대 255자]",
      OnbrdPartnerFinderProductSoldSection: "현재 판매된 제품",
      OnbrdPartnerFinderProdSoldAdobe: "판매된 제품 - Adobe",
      OnbrdPartnerFinderProdExpSoldOther:
        "판매된 제품 전문 지식 - 기타[최대 255자]",
      OnbrdPartnerFinderSrvcOfferedSection: "제공 서비스",
      AcctServicesOfferedErrorMsg:
        "선택한 값은 제공 서비스 그룹에서 고유해야 합니다.",
      OnbrdPartnerFinderVerticalFocusSection: "수직 시장",
      OnbrdPartnerFinderVertGovError:
        "공공 기관 고객에게 판매한 적이 있는지를 묻는 규정 준수 질문에 아니오로 응답했으므로 공공 기관을 선택할 수 없습니다.",
      OnbrdPartnerFinderVertEducError:
        "교육 기관 고객에게 판매한 적이 있는지를 묻는 규정 준수 질문에 아니오로 응답했으므로 교육 기관을 선택할 수 없습니다.",
      AcctVerticalSegmentErrorMsg:
        "선택한 값은 수직 시장 그룹에서 고유해야 합니다.",
      Previous: "이전",
      "Save and Exit": "저장 및 나가기",
      Submit: "제출",
      Next: "다음",

      select_level: "레벨 선택",
      basic_comp_info: "기본 회사 정보",
      location: "위치",
      comp_email_address: "회사 이메일 주소 *",
      save_n_exit_body:
        "등록 절차를 완료할 준비가 되면 언제든지 중단한 지점부터 다시 시작할 수 있습니다. 이 브라우저 창을 닫거나 다른 웹 사이트로 이동하십시오.",
      contact_type: "연락처 유형 (해당 사항을 모두 선택하십시오) *",
      confirm_deletion: "삭제 확인",
      delete_confirm_msg: " ",
      delete_confirm_msg1: " 연락처를 삭제하시겠습니까?",
      prog_agmt_text:
        "거의 다 되었습니다. 마지막으로 Partner Connection Program 리셀러 계약서를 읽은 후 표시된 부분에서 수락 여부를 확인하십시오.",
      add: "추가",
      Select: "선택",
      select_all_that_apply: "해당 사항을 모두 선택하십시오",
      i_certify: "다음 중 하나임을 증명합니다.",
      msg_saving_data: "양식 데이터 저장 중",
      msg_data_saved: "데이터가 저장되었습니다.",
      add_certified_contacts: "인증된 연락처 추가",
      add_certified_msg:
        "아래에 인증된 연락처의 세부 정보를 입력한 후 저장을 클릭하십시오.",
      course_completed: "이수한 교육 과정 ",
      course_completed_COC: "파트너 행동강령 – 상태",
      errorForNoCOC_1:
        " 신청서 진행을 위해서는 최소 한 분이 파트너 행동 강령 교육을 반드시 이수해 주셔야 합니다. 교육 이수를 위해서는, 아래 표에 제시된 링크를 통하여 어도비 채널 트레이닝 센터",
      errorForNoCOC_2: "Adobe Channel training Centre",
      errorForNoCOC_3:
        "에 접속해주세요. 교육 완료 후에는 연락처의 과정 완료 상태를 업데이트 하기 위해서 꼭 새로고침 버튼을 클릭하여 주세요.",
      logInCPButton: "Captivate Prime에 로그인하기",
      refresh: "새로고침",
      course_completed_ff: "이수한 교육 과정 (해당 사항을 모두 선택하십시오)",
      Register: "등록",
      "Contact Helpdesk": "헬프데스크에 문의",

      prog_agmt_checkbox:
        "본 문서에 명시된 약관을 읽고 이해했으며 이 약관을 준수할 것에 동의합니다. 그리고 리셀러를 구속할 수 있는 권한을 부여 받았음을 진술하고 보장합니다.",
      ConsolePartnerAccountListPartnerFinder: "파트너 찾기에 등재 (?)",
      ConsolePartnerContactHeader: "담당자",

      thank_you: "감사합니다.",
      ConsolePartnerConActive: "활성",
      Return_to_Adobe_Channel_Partners: "Adobe Partner Connection",
      "Continue Enrollment": "Continue Enrollment",
      problem_header: "문제가 발생했습니다.",
      sign_in: "Adobe ID로 로그인",
      associated_other_account:
        "(%{email})(으)로 로그인한 Adobe ID가 이미 다른 Adobe 파트너 프로그램, %{program}과(와) 연결되어 있습니다. 다른 Adobe ID로 로그인하거나 헬프데스크에 문의하여 등록을 계속할 수 있습니다.",
      OnbrdGenInvalidTokenErrMsg:
        "귀사의 링크가 이미 만료되었습니다. 헬프 데스크에 문의하십시오.",
    },
  },
  es_ES: {
    uplevelRenewal: {
      PP_Adobe_Portal: null,
      PP_APC_Header_Label: null,
      ONBUplevelInfo: "Selecciona el nivel deseado.",
      ONBNewLevel: "Nuevo nivel",
      OnbrdInterimUplevelHeader: "Seleccione el nivel al que desea aplicarlo.",
      OnbrdGenCertifiedLevel: null,
      OnbrdGenGoldLevel: null,
      OnbrdGenErrorLabel: "Error:",
      OnbrdGenInputErrorMsg: "Introduzca un valor.",
      NAUplevelProgramType: null,
      NAUplevelRetailSpecialization: null,
      OnbrdInterimSelectButton: "Seleccionar",

      ctr1_certified:
        "Los revendedores deben completar esta inscripción en línea y aceptar los términos y condiciones del Reseller Program.",
      ctr2_certified:
        "Los revendedores deben cumplir todos los requisitos para el nivel deseado. Consulte la Guía del Adobe Partner Connection Reseller Program para obtener una lista completa de los requisitos.",
      ctr1_gold:
        "Los revendedores deben completar esta inscripción en línea y aceptar los términos y condiciones del Reseller Program.",
      ctr2_gold:
        "Los revendedores deben cumplir todos los requisitos para el nivel deseado. Consulte la Guía del Adobe Partner Connection Reseller Program para obtener una lista completa de los requisitos.",

      PP_APC_Header_Label: null,
      OnbrdCriteriaAuthoriseMsg:
        "Marque donde se indique para confirmar que está autorizado para completar esta solicitud en nombre de su empresa.",
      OnbrdTermsPartnerCodeMsg:
        "Revise los términos y condiciones así como el código de conducta de socio empresarial de Adobe, y marque donde se indique para confirmar su aceptación.",
      OnbrdContactPrefLang: "Idioma preferido *",
      PP_Adobe_Portal: null,
      ONBLangPref: "Región e idioma",
      OnbrdCriteriaHeader: "Requisitos de inscripción",
      OnbrdCriteriaHeaderRenewal: "Criterios de renovación",
      OnbrdCriteriaHeaderUplevel: "Criterios de actualización a un nuevo nivel",
      ONBCompInfo: "Información de la empresa",
      ONBContsInfo: "Información de contacto",
      SplznQuestionnaireHeader: "Cuestionario",
      ONBPgmAgreement: "Acuerdo del programa",
      ONBPreferredLanguage:
        "Por favor, selecciona la ubicación de tu empresa y el idioma deseado.",
      OnbrdProfileRegion: "Región",
      OnbrdGenSelectErrorMsg: "Seleccione un valor.",
      OnbrdProfileCountry: "País",
      OnbrdGenNone: "--Ninguna--",
      ONBRegCriteriaAgree:
        "Por favor, revisa los requisitos de inscripción e indica tu aceptación.",
      OnbrdCriteriaBody:
        "Le agradecemos el interés mostrado en el Programa de Adobe Partner Connection Reseller Program.",
      OnbrdCriteriaBodyRenewal:
        "Le agradecemos el interés mostrado en la renovación de su inscripción del Adobe Partner Connection Reseller Program.",
      OnbrdCriteriaBodyUplevel:
        "Le agradecemos el interés mostrado en la actualización de su inscripción en el Adobe Partner Connection Reseller Program.",
      OnbrdCriteriaBody1:
        "El camino que debe seguir para inscribirse comienza con este proceso de inscripción en línea. Revise los requisitos del Reseller Program para el nivel deseado así como los requisitos de inscripción que se muestran a continuación. Cuando esté listo para continuar, confirme que está autorizado para completar esta solicitud. Después, haga clic en Siguiente para continuar.",
      OnbrdCriteriaSectionHeader: "Requisitos de inscripción",
      OnbrdCriteriaSectionHeaderRenewal: "CRITERIOS DE RENOVACIÓN",
      OnbrdCriteriaSectionHeaderUplevel:
        "CRITERIOS DE ACTUALIZACIÓN A UN NIVEL SUPERIOR",
      OnbrdCriteriaAuthorized: "responsable o director de la empresa",
      OnbrdCriteriaAuthorized2:
        "la persona autorizada expresamente por el responsable o director para completar esta solicitud en nombre de la empresa.",
      ONBEnterCompDetails:
        "Por favor, proporciona la siguiente información sobre tu empresa.",
      OnbrdProfileMembershipId: "ID de socio",
      OnbrdProfileParentMembershipId: "ID de socio matriz",
      OnbrdProfileContractStart: "Fecha de inicio de contrato",
      OnbrdProfilePartnerLevel: "Nivel de socio",
      OnbrdProfileContractEnd: "Fecha de finalización de contrato",
      OnbrdProfileSplzn: "Datos de especialista",
      OnbrdProfileAcctMgr: "Administrador de cuentas",
      OnbrdProfileAddLicenses: "# Licencias adicionales",
      OnbrdProfileFullCompName: "Nombre de la Empresa",
      OnbrdGenInputErrorMsg: "Introduzca un valor.",
      OnbrdProfileTradingName: "Nombre comercial",
      OnbrdProfileBRN: "Número de Identificación Fiscal",
      OnbrdProfilePreferredDistributor: "Mayorista Preferido",
      OnbrdProfileYrIncorp: "Año de creación *",
      OnbrdGenInvalidYrFormat: "Por favor siga el siguiente formato: YYYY",
      OnbrdGenInvalidYr: "Año no es válido.",
      OnbrdGenInvalidFutureDateMsg: null,
      OnbrdProfileCompType:
        "Tipo de empresa (Seleccionar todas las opciones aplicables) *",
      OnbrdProfileStreet: "Calle *",
      OnbrdProfileCity: "Ciudad *",
      OnbrdProfileState: "Estado/Provincia *",
      OnbrdProfilePostCode: "Código postal *",
      OnbrdProfilePrimPhone: "Teléfono principal *",
      OnbrdProfilePrimFax: "Fax",
      OnbrdProfileContactEmail: "Correo electrónico *",
      OnbrdGenEmailFormatErrMsg: "Formato de correo electrónico no válido.",
      OnbrdProfileCompanyDomainMsg:
        "El dominio del correo electrónico de empresa que ha introducido no coincide con el dominio del correo electrónico del contacto principal.",
      OnbrdProfileEmailDomain: "Dominio de correo electrónico",
      OnbrdProfilePrimURL: "Sitio web *",
      OnbrdProfileSecondaryURL: "Sitio web secundario",
      OnbrdProfileListPartnerFinder:
        "¿Desea que se le añada a la lista del buscador de revendedores?",
      ONBContactDetails:
        "Por favor, proporciona la información de contacto de tu empresa.",
      OnbrdContactSecContactInfo: "Datos de contacto",
      OnbrdContactSectionHeader:
        "NOTA: Se requieren contactos primarios y secundarios. Puede que desee añadir contactos adicionales para que nos pongamos en contacto con usted para fines comerciales, de marketing y de actualizaciones técnicas.",
      ONBAddSecBtn: "Añadir secundario",
      ONBAddOtherBtn: "Añadir otro",
      ReAssignContactNameLabel: "Nombre de contacto",
      ConsolePartnerContactEmail: "Correo electrónico",
      ConsolePartnerContactCType: "Tipo de contacto principal",
      TrngManage: "Gestionar",
      OnbrdContactPrimaryType: "Principal",
      OnbrdContactSecondaryType: "Secundario",
      OnbrdContactOtherType: "Otros",
      ConsolePartnerBtnEdit: "Editar",
      QBPDelete: "Eliminar",
      OnbrdContactPriConHeader: "Contacto Principal",
      OnbrdContactSecConHeader: "Contacto secundario",
      OnbrdContactOther: "Otros contactos",
      OnbrdContactPrefix: "Título (antepuesto al nombre)",
      OnbrdContactTitle: "Título (pospuesto al nombre)/puesto de trabajo",
      prefixMaxLengthError:
        "Prefix must be 10 characters or fewer, Kindly update.",
      suffixMaxLengthError:
        "Suffix must be 10 characters or fewer, Kindly update.",
      OnbrdContactFName: "Nombre *",
      OnbrdContactLName: "Apellido *",
      OnbrdContactPhone: "Teléfono *",
      OnbrdContactJRole: "Funciones del puesto *",
      OnbrdContactEmail: "Correo electrónico *",
      OnbrdContactAddtlType: "Tipo",
      OnbrdContactDeactivate: "Desactivar",
      OnbrdContactDeactivateHelp:
        "Al marcar la casilla de desactivación, se eliminará el contacto de la cuenta. Este contacto dejará de tener acceso a los sistemas de Adobe.",
      TrngSaveClose: "Guardar y cerrar",
      TrngClose: "Cerrar",
      ONBRegCerContacts:
        "Please select and complete the required COC training course before submitting your request.",
      OnbrdCertContactSectionHeader:
        ' Se requiere formación en ventas para el nivel deseado. Un mínimo de una persona debe completar la formación del "Código de conducta para socios". Consulte la Guía del programa de reseller o minoristas de Adobe Partner Connection para obtener una lista completa de los requisitos de formación. Identifique los contactos que han completado la formación requerida en los campos siguientes.',
      OnbrdContactAdd: "Agregar otro contacto",
      OnbrdCertContactFName: "Nombre",
      OnbrdCertContactLName: "Apellido",
      OnbrdCertContactEmail: "Correo electrónico",
      OnbrdCertContactCertification: "CURSO DE FORMACIÓN COMPLETADO",
      TrngManage: "Gestionar",
      ONBCerContactDetails: "Detalles de contacto certificados",
      OnbrdCertContactDeactivated: "DESACTIVAR",
      ONBRetailSplQues:
        "Cuestionario de la especialización del programa al por menor",
      OnbrdPrimaryQuestionnaireHeader:
        "Cuestionario de cumplimiento de inscripción",
      OnbrdSecondaryQuestionnaireHeader:
        "Cuestionario de inscripción secundario",
      OnbrdPartnerFinderInfoHeader: "Cuestionario de inscripción de empresa",
      ONBAgreeToSubmit:
        "Por favor, revisa el acuerdo del programa e indica tu aceptación.",
      OnbrdTermsSectionHeader2:
        "Por Favor revise los Términos y Condiciones del Reseller Program. Al Final del documento tendrá que marcar si accepta los mismos.",
      OnbrdTermsSectionHeader: "Términos y condiciones",
      OnbrdTermsAccept:
        "HE LEÍDO, COMPRENDO Y ACEPTO CUMPLIR LOS TÉRMINOS Y CONDICIONES AQUÍ ESTIPULADOS, Y DECLARO Y GARANTIZO QUE ESTOY AUTORIZADO A VINCULAR AL REVENDEDOR.",
      OnbrdThankYouNewRegistered:
        "Le agradecemos su interés mostrado en el Adobe Partner Connection Reseller Program. Hemos recibido su solicitud. En breve recibirá un correo electrónico de confirmación. Le informaremos a través del correo electrónico sobre cualquier actualización relativa a su solicitud.",
      OnbrdThankYouRenewalRegistered:
        "Se ha archivado su renovación y en breve recibirá un correo electrónico de confirmación. Le informaremos a través del correo electrónico sobre cualquier actualización relativa a su renovación.",
      OnbrdThankYouRenewalCertGold:
        "Se ha archivado su renovación y en breve recibirá un correo electrónico de confirmación. Le informaremos a través del correo electrónico sobre cualquier actualización relativa a su renovación.",
      OnbrdThankYouUplevelCertGold:
        "Le agradecemos el interés mostrado en la actualización a un nuevo nivel del Adobe Partner Connection Reseller Program. Hemos recibido su solicitud. En breve recibirá un correo electrónico de confirmación. Le informaremos a través del correo electrónico sobre cualquier actualización relativa a su solicitud.",
      OnbrdThankYouClick: "Haga clic",
      OnbrdThankYouEducURL:
        "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=Education&id=",
      OnbrdThankYouHere: "aquí",
      OnbrdThankYouEd: "para renovar su especialización en educación.",
      OnbrdThankYouLegalURL:
        "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=SAM+services&id=",
      OnbrdThankYouLeg: "para renovar su especialización en servicios SAM.",
      OnbrdThankYouProVedioURL:
        "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=ProVideo&id=",
      OnbrdThankYouPv: "para renovar su especialización en ProVideo.",
      OnbrdThankYouGovURL:
        "http://adobedealreg.sfqa.cs12.force.com/Onboarding/SplznWizardPage?sp=Government&id=",
      OnbrdThankYouGv: null,
      OnbrdThankYouDpsURL:
        "http://adobedealreg.force.com/Onboarding/SplznWizardPage?sp=DigitalPublishingSuite&id=",
      OnbrdThankYouDps: null,
      OnbrdThankYouHelpDesk:
        "Si tiene cualquier pregunta sobre el Adobe Partner Connection Reseller Program, póngase en contacto con el servicio de asistencia Adobe Partner Connection Help Desk",
      OnbrdErrorUnauthorized:
        "No está autorizado para ver esta página. Póngase en contacto con el servicio de asistencia de socios para recibir ayuda relativa al registro o la actualización.",
      OnbrdErrorNewRegEmailExist:
        "<br/><br/>\n<p>No se pudo procesar la inscripción porque su dirección de correo electrónico ya existe en el sistema.</p>\n<br/><br/><br/><br/><br/>",
      OnbrdErrorNewRegEmailFree:
        "<br/><br/> \n<p>No se permiten dominios de correo electrónico gratuitos ni proveedores de servicios de Internet como direcciones de correo electrónico principal o de la empresa. Para obtener un ID de Adobe, regístrese con una cuenta de correo electrónico corporativa.</p> \n<br/><br/><br/><br/><br/>",
      OnbrdErrorExpiredLink:
        "<br/><br/>\n<p>Su enlace ha expirado. Póngase en contacto con el servicio de asistencia Adobe Partner Connection Help Desk.</p>\n<br/><br/><br/><br/><br/>",
      OnbrdInterimUplevelExistsMsg:
        "Te agradecemos el interés mostrado en la actualización a un nuevo nivel del programa Adobe Partner Connection Program. Ya estamos revisando una aplicación enviada previamente para el nuevo nivel. Te informaremos a través del correo electrónico sobre cualquier actualización relativa a tu solicitud.",
      OnbrdProgNextStepExistMsg:
        "Este revendedor ya está registrado en el Programa de revendedores de Conexión de socios de Adobe. Debe notificar al revendedor su interés en participar en este programa haciendo clic en el botón Enviar correo electrónico, a continuación.",
      OnbrdGenPreviousLabel: "Anterior",
      OnbrdGenSaveExitLabel: "Guardar y salir",
      OnbrdGenSubmitLabel: "Enviar",
      OnbrdGenNextLabel: "Siguiente",
      OnbrdPartnerFinderProdExpOther:
        "Experto del Producto [Número máximo de 255 caracteres]",
      OnbrdPrimaryQuestionnaireSectionHeader:
        "Responda a las siguientes preguntas sobre su empresa.",
      renewal_unauthorized: "No está autorizado para ver esta página.",

      OnbrdPartnerFinderInfoBusProfSection: "Perfil empresarial",
      OnbrdPartnerFinderSSCountriesAmerica:
        "Asistencia y ventas en otros países (América)",
      OnbrdPartnerFinderSSCountriesEurope:
        "Asistencia y ventas en otros países (Europa y Asia Central)",
      OnbrdPartnerFinderSSCountriesAfrica:
        "Asistencia y ventas en otros países (África y Oriente Medio)",
      OnbrdPartnerFinderSSCountiresAsia:
        "Asistencia y ventas en otros países (Asia-Pacífico)",
      OnbrdPartnerFinderBusinessDescEng:
        "Descripción empresarial (Inglés) [Número máximo de 255 caracteres]",
      OnbrdLengthValidationErrorMsg: "Introduzca un máximo de 255 caracteres.",
      OnbrdPartnerFinderAltLang: "Idioma alternativo",
      OnbrdPartnerFinderBusinessDescOther:
        "Descripción empresarial (otro idioma) [Número máximo de 255 caracteres]",
      OnbrdPartnerFinderOrgSizeSection: "Tamaño de organización",
      OnbrdPartnerFinderTotalEmp: "Número total de empleados",
      OnbrdPartnerFinderTotInsideTelSFDC:
        "Número total de empleados del personal de ventas interno/por teléfono",
      OnbrdPartnerFinderTotOutsideDirSFDC:
        "Número total de empleados del personal de ventas externo/directo",
      OnbrdPartnerFinderTotTechProfOnStaff:
        "Número total de profesionales técnicos en plantilla",
      OnbrdPartnerFinderTotDevOnStaff:
        "Número total de desarrolladores en plantilla",
      OnbrdPartnerFinderTotMarkProfOnStaff:
        "Número total de profesionales de marketing en plantilla",
      OnbrdPartnerFinderCustSegmentSection: "Segmento de clientes",
      OnbrdPartnerFinderPrimFocus: "Objetivo principal",
      OnbrdGenErrorLabel: "Error:",
      AcctCustomerSegmentErrorMsg:
        "El valor seleccionado debe ser exclusivo dentro del grupo Segmento de clientes.",
      OnbrdPartnerFinderSecFocus: "Objetivo secundario",
      OnbrdPartnerFinderNotSig: "No relevante",
      OnbrdPartnerFinderProdExpSection: "Experiencia en venta de productos",
      OnbrdPartnerFinderProdExpAdobe: "Experiencia en productos (Adobe)",
      OnbrdPartnerFinderProdExpOther:
        "Experto del Producto [Número máximo de 255 caracteres]",
      OnbrdPartnerFinderProductSoldSection: "Productos vendidos actualmente",
      OnbrdPartnerFinderProdSoldAdobe: "Productos vendidos (Adobe)",
      OnbrdPartnerFinderProdExpSoldOther:
        "Experdo del producto vendido [Número máximo de 255 caracteres]",
      OnbrdPartnerFinderSrvcOfferedSection: "Servicios ofrecidos",
      AcctServicesOfferedErrorMsg:
        "El valor seleccionado debe ser exclusivo dentro del grupo Servicios ofrecidos.",
      OnbrdPartnerFinderVerticalFocusSection: "Objetivo vertical",
      OnbrdPartnerFinderVertGovError:
        "No puede elegir Gobierno porque contestó no a la pregunta de conformidad que decia relacionada a la venta a clientes de Gobierno.",
      OnbrdPartnerFinderVertEducError:
        "No puede elegir Educación porque contestó no a la pregunta de conformidad que decia relacionada a la venta a clientes de Educación.",
      AcctVerticalSegmentErrorMsg:
        "El valor seleccionado debe ser exclusivo dentro del grupo Segmento vertical.",
      Previous: "Anterior",
      "Save and Exit": "Guardar y salir",
      Submit: "Enviar",
      Next: "Siguiente",

      select_level: "Seleccionar nivel",
      basic_comp_info: "Información básica de la empresa",
      location: "Ubicación",
      comp_email_address: "Dirección de correo electrónico de la empresa *",
      save_n_exit_body:
        "Vuelve cuando quieras completar el proceso de inscripción. Volverás al lugar en el que lo dejaste. Ahora puedes cerrar esta ventana del explorador o navegar a otro sitio web.",
      contact_type:
        "Tipo de contacto (Seleccionar todas las opciones aplicables) *",
      confirm_deletion: "Confirmar eliminación",
      delete_confirm_msg: "¿Estás seguro de que deseas eliminar el contacto: ",
      delete_confirm_msg1: "?",
      prog_agmt_text:
        "Casi hemos acabado. El último paso consiste en leer el acuerdo de distribuidor Partner Connection Program. Confirma tu aceptación donde se indica.",
      add: "Agregar",
      Select: "Seleccionar",
      select_all_that_apply: "Seleccionar todas las opciones aplicables",
      i_certify: "Certifico que soy:",
      msg_saving_data: "Guardando los datos del formulario.",
      msg_data_saved: "Se han guardado los datos.",
      add_certified_contacts: "Añadir contactos certificados",
      add_certified_msg:
        "Añade los detalles de los contactos certificados abajo. A continuación, haz clic en Guardar.",
      course_completed: "Cursos de formación completados ",
      course_completed_COC: "Código de conducta de los socios - Estatus",
      errorForNoCOC_1:
        "Al menos una persona debe completar la formación sobre el Código de Conducta de los Socios para proceder a la solicitud. Para completar la formación, abra ",
      errorForNoCOC_2: "“Adobe Channel training Centre”",
      errorForNoCOC_3:
        " utilizando el enlace que aparece debajo de la tabla. Una vez que haya completado la formación, haga clic en el botón REFRESCAR para actualizar el estado de finalización del curso de los contactos.",
      logInCPButton: "Inicie sesión en Captivate Prime:",
      refresh: "Refrescar",
      course_completed_ff:
        "Cursos de formación completados (Seleccionar todas las opciones aplicables)",
      Register: "Regístrate",
      "Contact Helpdesk": "Contactar con el servicio de asistencia",
      prog_agmt_checkbox:
        "HE LEÍDO, COMPRENDO Y ACEPTO CUMPLIR LOS TÉRMINOS Y CONDICIONES AQUÍ ESTIPULADOS, Y DECLARO Y GARANTIZO QUE ESTOY AUTORIZADO A VINCULAR AL REVENDEDOR.",
      ConsolePartnerAccountListPartnerFinder:
        "¿Desea que se le añada a la lista del buscador de revendedores?",
      ConsolePartnerContactHeader: "Contactos",

      thank_you: "Gracias.",
      ConsolePartnerConActive: "Activo",
      Return_to_Adobe_Channel_Partners: "Adobe Partner Connection",
      "Continue Enrollment": "Continuar la inscripción",
      problem_header: "Ha habido un problema.",
      sign_in: "Iniciar sesión con Adobe ID",
      associated_other_account:
        "El Adobe ID con el que has iniciado sesión (%{email}) ya está asociado con otro programa de socios de Adobe: %{program}. Puedes iniciar sesión con otro Adobe ID o ponerte en contacto con el servicio de asistencia para continuar con tu registro.",
      OnbrdGenInvalidTokenErrMsg:
        "Su enlace ya ha caducado. Póngase en contacto con el servicio de asistencia.",
    },
  },
};

export default uplvlRenewTranslation;
